import { Button, FormGroup, H2, H3, H4, H5, HTMLSelect, InputGroup, Switch, TextArea } from "@blueprintjs/core";
import { Businesses } from "@just-in-types";
// import { Editor } from '@tinymce/tinymce-react';
import InputMask from "imask";
import * as React from "react";
import { SketchPicker } from "react-color";
import FileUploader from "react-firebase-file-uploader";
import { connect } from "react-redux";
import { emptySiteOptions } from "../adminFunctions/cleanSites";
import firebase from "../firebase";
import { getBusinessData, updateShortcode, UpdateSiteOptions, updateSiteOptions } from "../store/actions";

interface ISiteTreeOptionsDispatchProps {
  onUpdateSiteOptions: UpdateSiteOptions;
}

interface ISiteTreeOptionsOwnProps {
  businessId: string;
  site: Businesses.Site;
  siteId: string;
}

type SiteTreeOptionsProps = ISiteTreeOptionsDispatchProps & ISiteTreeOptionsOwnProps;

type SiteOptionsKey = keyof Businesses.SiteOptions;

interface SiteTreeOptionsState {
  businessName: string;
  colorPickerOptions: any;
  shortcode: string;
  shortcodeDisabled: boolean;
  siteOptions: Businesses.SiteOptions;
  siteOptionsDisabled: { [K in SiteOptionsKey]: boolean };
  tinyEngEditor:any;
  tinySpnEditor:any;
}

type SwitchInputName =
  | "allowOptOut"
  | "disableKeyboard"
  | "noCheckIn"
  | "showCoupons"
  | "enableExpanolBtn"
  | "smartMatching"
  | "enableItalic"
  | "enableRowInTxtMsg"
  | "enableVipClub"
  | "homeBtnEnable"
  | "showLoyaltyReward"
  | "kioskUiHideAdvIn"
  | "kioskUiHideAdvOut"
  | "kioskUiHideCity"
  | "kioskUiHideContBtn"
  | "kioskUiWaiverScroll"
  | "kioskUiVehicleConfig"
  | "kioskUiHideDefaultWaiver"
  | "kioskUiShowSigSmiley"
  | "kioskUiAllInOneCheckIn"
  | "kioskUiLogoBorderEnable"
  | "kioskUiTabletView"
  | "kioskUiSigHideAdvIn"
  | "kioskUiSigHideAdvOut";
type TextInputName =
  | "descSize"
  | "descSizeM"
  | "descType"
  | "descText"
  | "descTextSecondline"
  | "descTextSpanish"
  | "descTextSpanishSecondline"
  // |"descTypeM"
  | "guid"
  | "heightForDesktop"
  | "heightForMobile"
  | "helpMenu"
  | "helpMenus"
  | "howitworksText"
  | "howitworksBgColor"
  | "howitworksColor"
  | "howitworksTexts"
  | "homeBtnUrl"
  | "englishKeyword"
  | "englishLocation"
  | "englishVipClubCheckboxText"
  | "englishVipClubHoverText"
  | "spanishKeyword"
  | "spanishLocation"
  | "spanishVipClubCheckboxText"
  | "spanishVipClubHoverText"
  | "homeButtonBgColor"
  | "homeButtonColor"
  | "homeButtonText"
  | "homeButtonTextSpanish"
  | "kioskName"
  | "kioskNameEs"
  | "s3Id"
  | "ivision code"
  | "siteName"
  // | "titleText"
  | "titleSize"
  | "retToPageSize"
  | "accessDashboardSize"
  | "accessDashboardSizeM"
  | "accessDashboardText"
  | "accessDashboardTextSpanish"
  | "accessDashboardType"
  | "retToPageSizeM"
  | "retToPageType"
  | "retToPageText"
  | "retToPageTextSpanish"
  | "titleSizeM"
  | "titleType"
  | "titleText"
  | "titleTextSpanish"
  | "tncSize"
  | "tncSizeM"
  | "tncType"
  | "tncText"
  | "tncTextSpanish"
  // | "titleTypeM"
  | "isArchive"
  | "allowOptOut"
  | "disableKeyboard"
  | "noCheckIn"
  | "showCoupons"
  | "enableExpanolBtn"
  | "smartMatching"
  | "homeBtnEnable"
  | "enableItalic"
  | "enableRowInTxtMsg"
  | "enableVipClub"
  | "urgId"
  | "jiSignUpUiBackgroundColor"
  | "jiSignUpUiFontColor"
  | "kioskUiBackgroundColor"
  | "kioskUiButtonDisabledColor"
  | "kioskUiButtonErrorColor"
  | "kioskUiButtonKeyColor"
  | "kioskUiButtonPrimaryColor"
  | "kioskUiButtonSuccessColor"
  | "kioskUiContinueBtnTextColor"
  | "kioskUiLogoBorderColor"
  | "howitworksImg"
  | "kioskUiInAdvFile1"
  | "kioskUiInAdvFile2"
  | "kioskUiInAdvFile3"
  | "kioskUiInAdvFile4"
  | "kioskUiInAdvFile5"
  | "kioskUiInAdvFile6"
  | "kioskUiInAdvFile7"
  | "kioskUiInAdvFile8"
  | "kioskUiInAdvFile9"
  | "kioskUiInAdvFile10"
  | "kioskUiOutAdvFile1"
  | "kioskUiOutAdvFile2"
  | "kioskUiOutAdvFile3"
  | "kioskUiOutAdvFile4"
  | "kioskUiOutAdvFile5"
  | "kioskUiOutAdvFile6"
  | "kioskUiOutAdvFile7"
  | "kioskUiOutAdvFile8"
  | "kioskUiOutAdvFile9"
  | "kioskUiOutAdvFile10"
  | "kioskUiSigInAdvFile1"
  | "kioskUiSigInAdvFile2"
  | "kioskUiSigInAdvFile3"
  | "kioskUiSigInAdvFile4"
  | "kioskUiSigInAdvFile5"
  | "kioskUiSigInAdvFile6"
  | "kioskUiSigInAdvFile7"
  | "kioskUiSigInAdvFile8"
  | "kioskUiSigInAdvFile9"
  | "kioskUiSigInAdvFile10"
  | "kioskUiSigOutAdvFile1"
  | "kioskUiSigOutAdvFile2"
  | "kioskUiSigOutAdvFile3"
  | "kioskUiSigOutAdvFile4"
  | "kioskUiSigOutAdvFile5"
  | "kioskUiSigOutAdvFile6"
  | "kioskUiSigOutAdvFile7"
  | "kioskUiSigOutAdvFile8"
  | "kioskUiSigOutAdvFile9"
  | "kioskUiSigOutAdvFile10"
  | "kioskUiTermTextColor"
  | "kioskUiTermTextSize"
  | "kioskUiTermTextSize"
  | "kioskUiTextColor"
  | "kioskUiTextEngEditor"
  | "kioskUiTextSpnEditor"
  | "kioskUiTitleTextColor"
  | "widthForDesktop"
  | "widthForMobile"
  | "kioskUiAdvDelaySec"
  | "kioskUiAdvWidth"
  | "kioskUiAdvHeight"
  | "kioskUiAdvTop"
  | "kioskUiAdvBottom"
  | "kioskUiLogoHeight"
  | "kioskUiLogoWidth";
type InputName = SwitchInputName | TextInputName;

const isValidSwitchInputName = (name: string): name is SwitchInputName =>
  name === "allowOptOut" ||
  name === "disableKeyboard" ||
  name === "noCheckIn" ||
  name === "showCoupons" ||
  name === "homeBtnEnable" ||
  name === "enableExpanolBtn" ||
  name === "smartMatching" ||
  name === "enableItalic" ||
  name === "enableRowInTxtMsg" ||
  name === "enableVipClub" ||
  name === "showLoyaltyReward" ||
  name === "kioskUiHideAdvIn" ||
  name === "kioskUiHideAdvOut" ||
  name === "kioskUiHideCity" ||
  name === "kioskUiHideContBtn" ||
  name === "kioskUiVehicleConfig" ||
  name === "kioskUiWaiverScroll" ||
  name === "kioskUiHideDefaultWaiver" ||
  name === "kioskUiShowSigSmiley" ||
  name === "kioskUiAllInOneCheckIn" ||
  name === "kioskUiLogoBorderEnable" ||
  name === "kioskUiTabletView" ||
  name === "kioskUiSigHideAdvIn" ||
  name === "kioskUiSigHideAdvOut";

const isValidTextInputName = (name: string): name is TextInputName =>
  name === "descSize" ||
  name === "descSizeM" ||
  name === "descType" ||
  name === "descText" ||
  name === "descTextS" ||
  name === "descTextSecondline" ||
  name === "descTextSpanish" ||
  name === "descTextSpanishSecondline" ||
  name === "guid" ||
  name === "heightForDesktop" ||
  name === "heightForMobile" ||
  name === "helpMenu" ||
  name === "helpMenus" ||
  name === "howitworksBgColor" ||
  name === "howitworksColor" ||
  name === "howitworksText" ||
  name === "howitworksTexts" ||
  name === "homeBtnUrl" ||
  name === "englishKeyword" ||
  name === "englishLocation" ||
  name === "englishVipClubCheckboxText" ||
  name === "englishVipClubHoverText" ||
  name === "spanishKeyword" ||
  name === "spanishLocation" ||
  name === "spanishVipClubCheckboxText" ||
  name === "spanishVipClubHoverText" ||
  name === "homeButtonBgColor" ||
  name === "homeButtonColor" ||
  name === "homeButtonText" ||
  name === "homeButtonTextSpanish" ||
  name === "kioskName" ||
  name === "kioskNameEs" ||
  name === "s3Id" ||
  name === "ivision code" ||
  name === "siteName" ||
  // name === "titleText" ||
  name === "titleSize" ||
  name === "retToPageSize" ||
  name === "accessDashboardSize" ||
  name === "accessDashboardSizeM" ||
  name === "accessDashboardText" ||
  name === "accessDashboardTextSpanish" ||
  name === "accessDashboardType" ||
  name === "retToPageSizeM" ||
  name === "retToPageText" ||
  name === "retToPageTextSpanish" ||
  name === "retToPageType" ||
  name === "titleSizeM" ||
  name === "titleType" ||
  name === "titleText" ||
  name === "titleTextSpanish" ||
  name === "tncSize" ||
  name === "tncSizeM" ||
  name === "tncType" ||
  name === "tncText" ||
  name === "tncTextSpanish" ||
  // name === "titleTypeM" ||
  name === "urgId" ||
  name === "jiSignUpUiBackgroundColor" ||
  name === "jiSignUpUiFontColor" ||
  name === "kioskUiBackgroundColor" ||
  name === "kioskUiButtonDisabledColor" ||
  name === "kioskUiButtonErrorColor" ||
  name === "kioskUiButtonKeyColor" ||
  name === "kioskUiButtonPrimaryColor" ||
  name === "kioskUiButtonSuccessColor" ||
  name === "kioskUiContinueBtnTextColor" ||
  name === "kioskUiLogoBorderColor" ||
  name === "kioskUiTermTextColor" ||
  name === "kioskUiTermTextSize" ||
  name === "kioskUiTextColor" ||
  name === "kioskUiTextEngEditor" ||
  name === "kioskUiTextSpnEditor" ||
  name === "kioskUiTitleTextColor" ||
  name === "widthForDesktop" ||
  name === "widthForMobile" ||
  name === "kioskUiAdvDelaySec" ||
  name === "kioskUiAdvWidth" ||
  name === "kioskUiAdvHeight" ||
  name === "kioskUiAdvTop" ||
  name === "kioskUiAdvBottom" ||
  name === "kioskUiLogoHeight" ||
  name === "kioskUiLogoWidth";

const TextInputGroup = ({
  disabled,
  innerRef,
  name,
  onChange,
  onClick,
  value,
}: {
  disabled: boolean;
  innerRef?: (ref: HTMLInputElement | null) => HTMLInputElement | null;
  name: TextInputName;
  onChange: SiteTreeOptions["handleTextChange"];
  onClick: SiteTreeOptions["handleChangeButton"];
  value: string;
}) => (
  <FormGroup label={name}>
    <InputGroup
      {...{ disabled, name, value }}
      inputRef={innerRef}
      onChange={onChange}
      rightElement={
        <Button {...{ disabled, name, onClick, value }} intent="primary" minimal={true}>
          change
        </Button>
      }
    />
  </FormGroup>
);

const TextInputGroupColor = ({
  disabled,
  innerRef,
  name,
  label,
  onChange,
  onClick,
  value,
  colorPickerOptions,
  onClickPicker,
  handleChangePicker,
}: {
  disabled: boolean;
  innerRef?: (ref: HTMLInputElement | null) => HTMLInputElement | null;
  name: TextInputName;
  label: string;
  onChange: SiteTreeOptions["handleTextChange"];
  onClick: SiteTreeOptions["handleChangeButton"];
  value: string;
  colorPickerOptions: any;
  onClickPicker: SiteTreeOptions["onClickPicker"];
  handleChangePicker: SiteTreeOptions["handleChangePicker"];
}) => (
  <FormGroup label={label}>
    <InputGroup
      {...{ disabled, name, value }}
      inputRef={innerRef}
      onChange={onChange}
      rightElement={
        <Button {...{ disabled, name, onClick, value }} intent="primary" minimal={true}>
          change
        </Button>
      }
    />
    <Button intent="danger" minimal={true} {...{ name, value }} onClick={onClickPicker}>
      Picker
    </Button>
    {colorPickerOptions.onOpen ? (
      <SketchPicker color={colorPickerOptions.background} onChange={(event) => handleChangePicker(event, name)} />
    ) : (
      ""
    )}
  </FormGroup>
);

const siteOptionsEnabled: SiteTreeOptionsState["siteOptionsDisabled"] = {
  accessDashboardSize: false,
  accessDashboardSizeM: false,
  accessDashboardText: false,
  accessDashboardTextSpanish: false,
  accessDashboardType: false,
  allowOptOut: false,
  descSize: false,
  descSizeM: false,
  descText: false,
  descTextSecondline: false,
  descTextSpanish: false,
  descTextSpanishSecondline: false,
  descType: false,
  // descTypeM: false,
  disableKeyboard: false,
  enableExpanolBtn: false,
  enableItalic: false,
  enableRowInTxtMsg: false,
  enableVipClub: false,
  englishKeyword: false,
  englishLocation: false,
  englishVipClubCheckboxText: false,
  englishVipClubHoverText: false,
  guid: false,
  heightForDesktop: false,
  heightForMobile: false,
  helpMenu: false,
  helpMenus: false,
  homeBtnEnable: false,
  homeBtnUrl: false,
  homeButtonBgColor: false,
  homeButtonColor: false,
  homeButtonText: false,
  homeButtonTextSpanish: false,
  howitworksBgColor: false,
  howitworksColor: false,
  howitworksImg: false,
  howitworksText: false,
  howitworksTexts: false,
  isArchive: false,
  jiSignUpUiBackgroundColor: false,
  jiSignUpUiFontColor: false,
  keyword: false,
  keywordEs: false,
  kioskName: false,
  kioskNameEs: false,
  kioskUiAdvBottom: false,
  kioskUiAdvDelaySec: false,
  kioskUiAdvHeight: false,
  kioskUiAdvTop: false,
  kioskUiAdvWidth: false,
  kioskUiAllInOneCheckIn: false,
  kioskUiBackgroundColor: false,
  kioskUiButtonDisabledColor: false,
  kioskUiButtonErrorColor: false,
  kioskUiButtonKeyColor: false,
  kioskUiButtonPrimaryColor: false,
  kioskUiButtonSuccessColor: false,
  kioskUiContinueBtnTextColor: false,
  kioskUiHideAdvIn: false,
  kioskUiHideAdvOut: false,
  kioskUiHideCity: false,
  kioskUiHideContBtn: false,
  kioskUiHideDefaultWaiver: false,
  kioskUiInAdvFile1: false,
  kioskUiInAdvFile10: false,
  kioskUiInAdvFile2: false,
  kioskUiInAdvFile3: false,
  kioskUiInAdvFile4: false,
  kioskUiInAdvFile5: false,
  kioskUiInAdvFile6: false,
  kioskUiInAdvFile7: false,
  kioskUiInAdvFile8: false,
  kioskUiInAdvFile9: false,
  kioskUiLogoBorderColor: false,
  kioskUiLogoBorderEnable: false,
  kioskUiLogoHeight: false,
  kioskUiLogoWidth: false,
  kioskUiOutAdvFile1: false,
  kioskUiOutAdvFile10: false,
  kioskUiOutAdvFile2: false,
  kioskUiOutAdvFile3: false,
  kioskUiOutAdvFile4: false,
  kioskUiOutAdvFile5: false,
  kioskUiOutAdvFile6: false,
  kioskUiOutAdvFile7: false,
  kioskUiOutAdvFile8: false,
  kioskUiOutAdvFile9: false,
  kioskUiShowSigSmiley: false,
  kioskUiTabletView: false,
  kioskUiSigHideAdvIn: false,
  kioskUiSigHideAdvOut: false,
  kioskUiSigInAdvFile1: false,
  kioskUiSigInAdvFile10: false,
  kioskUiSigInAdvFile2: false,
  kioskUiSigInAdvFile3: false,
  kioskUiSigInAdvFile4: false,
  kioskUiSigInAdvFile5: false,
  kioskUiSigInAdvFile6: false,
  kioskUiSigInAdvFile7: false,
  kioskUiSigInAdvFile8: false,
  kioskUiSigInAdvFile9: false,
  kioskUiSigOutAdvFile1: false,
  kioskUiSigOutAdvFile10: false,
  kioskUiSigOutAdvFile2: false,
  kioskUiSigOutAdvFile3: false,
  kioskUiSigOutAdvFile4: false,
  kioskUiSigOutAdvFile5: false,
  kioskUiSigOutAdvFile6: false,
  kioskUiSigOutAdvFile7: false,
  kioskUiSigOutAdvFile8: false,
  kioskUiSigOutAdvFile9: false,
  kioskUiTermTextColor: false,
  kioskUiTermTextSize: false,
  kioskUiTextColor: false,
  kioskUiTextEngEditor: false,
  kioskUiTextSpnEditor: false,
  kioskUiTitleTextColor: false,
  kioskUiVehicleConfig: false,
  kioskUiWaiverScroll: false,
  noCheckIn: false,
  optInField: false,
  retToPageSize: false,
  retToPageSizeM: false,
  retToPageText: false,
  retToPageTextSpanish: false,
  retToPageType: false,
  s3Id: false,
  shortcode: false,
  showCoupons: false,
  showLoyaltyReward: false,
  siteName: false,
  smartMatching: false,
  spanishKeyword: false,
  spanishLocation: false,
  spanishVipClubCheckboxText: false,
  spanishVipClubHoverText: false,
  // titleText: false,
  titleSize: false,
  titleSizeM: false,
  titleText: false,
  titleTextSpanish: false,
  titleType: false,
  tncSize: false,
  tncSizeM: false,
  tncText: false,
  tncTextSpanish: false,
  tncType: false,
  // titleTypeM: false,
  urgId: false,
  widthForDesktop: false,
  widthForMobile: false,
};

class SiteTreeOptions extends React.Component<SiteTreeOptionsProps, SiteTreeOptionsState> {
  public sizeArray: string[] = [];
  public typeArray = [
    "Verdana, sans-serif",
    "'Times New Roman', Times, serif",
    "Arial, Helvetica, sans-serif",
    "'Lucida Console', 'Courier New', monospace",
  ];
  public delaySecondArray: any = [];

  public guidInterval: number;
  public guidInput: null | HTMLInputElement = null;
  public guidInputMask: null | any = null;

  public initialState: SiteTreeOptionsState = {
    businessName:'',
    colorPickerOptions: {},
    shortcode: "",
    shortcodeDisabled: false,
    siteOptions: emptySiteOptions,
    siteOptionsDisabled: siteOptionsEnabled,
    tinyEngEditor:null,
    tinySpnEditor:null,
  };

  constructor(props: SiteTreeOptionsProps) {
    super(props);
    this.state = this.initialState;
    this.sizeArrayFnc();
  }

  public componentDidMount() {
    // console.log("buss shortcode..");
    // console.log(this.props);
    this.buildSiteOptions();
    this.initInputMask();
    this.getBusinessData();
  }

  public componentDidUpdate({ site: { siteId: prevSiteId } }: SiteTreeOptionsProps) {
    const {
      site: { siteId },
    } = this.props;

    if (prevSiteId !== siteId) {
      this.setState(this.initialState);
    }

    // console.log("buss shortcode..");
    // console.log(this.props);
  }

  public componentWillUnmount() {
    if (this.guidInterval) {
      window.clearInterval(this.guidInterval);
    }
  }

  public render() {
    const {
      colorPickerOptions,
      shortcode,
      shortcodeDisabled,
      siteOptions: {
        accessDashboardSize,
        accessDashboardSizeM,
        accessDashboardText,
        accessDashboardTextSpanish,
        accessDashboardType,
        allowOptOut,
        descSize,
        descSizeM,
        descText,
        descTextSecondline,
        descTextSpanish,
        descTextSpanishSecondline,
        descType,
        // descTypeM,
        disableKeyboard,
        enableExpanolBtn,
        enableItalic,
        enableRowInTxtMsg,
        enableVipClub,
        englishKeyword,
        englishLocation,
        englishVipClubCheckboxText,
        englishVipClubHoverText,
        guid,
        heightForDesktop,
        heightForMobile,
        helpMenu,
        helpMenus,
        homeBtnEnable,
        homeBtnUrl,
        homeButtonBgColor,
        homeButtonColor,
        homeButtonText,
        homeButtonTextSpanish,
        howitworksBgColor,
        howitworksColor,
        howitworksImg,
        howitworksText,
        howitworksTexts,
        isArchive,
        kioskName,
        kioskNameEs,
        noCheckIn,
        retToPageSize,
        retToPageSizeM,
        retToPageText,
        retToPageTextSpanish,
        retToPageType,
        s3Id,
        showCoupons,
        showLoyaltyReward,
        siteName,
        smartMatching,
        // titleText,
        titleSize,
        titleSizeM,
        titleText,
        titleTextSpanish,
        titleType,
        tncSize,
        tncSizeM,
        tncText,
        tncTextSpanish,
        tncType,
        // titleTypeM,
        urgId,
        jiSignUpUiBackgroundColor,
        jiSignUpUiFontColor,
        kioskUiAdvDelaySec,
        kioskUiAdvWidth,
        kioskUiAdvHeight,
        kioskUiAdvTop,
        kioskUiAdvBottom,
        kioskUiAllInOneCheckIn,
        kioskUiBackgroundColor,
        kioskUiButtonDisabledColor,
        kioskUiButtonErrorColor,
        kioskUiButtonKeyColor,
        kioskUiButtonPrimaryColor,
        kioskUiButtonSuccessColor,
        kioskUiContinueBtnTextColor,
        kioskUiHideAdvIn,
        kioskUiHideAdvOut,
        kioskUiHideCity,
        kioskUiHideContBtn,
        // kioskUiHideDefaultWaiver,
        kioskUiInAdvFile1,
        kioskUiInAdvFile2,
        kioskUiInAdvFile3,
        kioskUiInAdvFile4,
        kioskUiInAdvFile5,
        kioskUiInAdvFile6,
        kioskUiInAdvFile7,
        kioskUiInAdvFile8,
        kioskUiInAdvFile9,
        kioskUiInAdvFile10,
        kioskUiLogoBorderColor,
        kioskUiLogoBorderEnable,
        kioskUiLogoHeight,
        kioskUiLogoWidth,
        kioskUiOutAdvFile1,
        kioskUiOutAdvFile2,
        kioskUiOutAdvFile3,
        kioskUiOutAdvFile4,
        kioskUiOutAdvFile5,
        kioskUiOutAdvFile6,
        kioskUiOutAdvFile7,
        kioskUiOutAdvFile8,
        kioskUiOutAdvFile9,
        kioskUiOutAdvFile10,
        kioskUiShowSigSmiley,
        kioskUiTabletView,
        kioskUiSigHideAdvIn,
        kioskUiSigHideAdvOut,
        kioskUiSigInAdvFile1,
        kioskUiSigInAdvFile2,
        kioskUiSigInAdvFile3,
        kioskUiSigInAdvFile4,
        kioskUiSigInAdvFile5,
        kioskUiSigInAdvFile6,
        kioskUiSigInAdvFile7,
        kioskUiSigInAdvFile8,
        kioskUiSigInAdvFile9,
        kioskUiSigInAdvFile10,
        kioskUiSigOutAdvFile1,
        kioskUiSigOutAdvFile2,
        kioskUiSigOutAdvFile3,
        kioskUiSigOutAdvFile4,
        kioskUiSigOutAdvFile5,
        kioskUiSigOutAdvFile6,
        kioskUiSigOutAdvFile7,
        kioskUiSigOutAdvFile8,
        kioskUiSigOutAdvFile9,
        kioskUiSigOutAdvFile10,
        kioskUiTermTextColor,
        kioskUiTermTextSize,
        kioskUiTextColor,
        // kioskUiTextEngEditor,
        // kioskUiTextSpnEditor,
        kioskUiTitleTextColor,
        kioskUiVehicleConfig,
        kioskUiWaiverScroll,
        spanishKeyword,
        spanishLocation,
        spanishVipClubCheckboxText,
        spanishVipClubHoverText,
        widthForDesktop,
        widthForMobile,
      },
      siteOptionsDisabled: {
        accessDashboardSize: accessDashboardSizeDisabled,
        accessDashboardSizeM: accessDashboardSizeMDisabled,
        accessDashboardText: accessDashboardTextDisabled,
        accessDashboardTextSpanish: accessDashboardTextSpanishDisabled,
        accessDashboardType: accessDashboardTypeDisabled,
        allowOptOut: allowOptOutDisabled,
        descSize: descSizeDisabled,
        descSizeM: descSizeMDisabled,
        descText: descTextDisabled,
        descTextSecondline: descTextSecondlineDisabled,
        descTextSpanish: descTextSpanishDisabled,
        descTextSpanishSecondline: descTextSpanishSecondlineDisabled,
        descType: descTypeDisabled,
        // descTypeM: descTypeMDisabled,
        disableKeyboard: disableKeyboardDisabled,
        enableExpanolBtn: enableExpanolBtnDisabled,
        enableItalic: enableItalicDisabled,
        enableRowInTxtMsg: enableRowInTxtMsgDisabled,
        enableVipClub: enableVipClubDisabled,
        englishKeyword: englishKeywordDisabled,
        englishLocation: englishLocationDisabled,
        englishVipClubCheckboxText: englishVipClubCheckboxTextDisabled,
        englishVipClubHoverText: englishVipClubHoverTextDisabled,
        guid: guidDisabled,
        heightForDesktop: heightForDesktopDisabled,
        heightForMobile: heightForMobileDisabled,
        // helpMenu: helpMenuDisabled,
        homeBtnEnable: homeBtnEnableDisabled,
        homeBtnUrl: homeBtnUrlDisabled,
        homeButtonBgColor: homeButtonBgColorDisabled,
        homeButtonColor: homeButtonColorDisabled,
        homeButtonText: homeButtonTextDisabled,
        homeButtonTextSpanish: homeButtonTextSpanishDisabled,
        howitworksBgColor: howitworksBgColorDisabled,
        howitworksColor: howitworksColorDisabled,
        howitworksText: howitworksTextDisabled,
        howitworksTexts: howitworksTextsDisabled,
        kioskName: kioskNameDisabled,
        kioskNameEs: kioskNameEsDisabled,
        noCheckIn: noCheckInDisabled,
        retToPageSize: retToPageSizeDisabled,
        retToPageSizeM: retToPageSizeMDisabled,
        retToPageText: retToPageTextDisabled,
        retToPageTextSpanish: retToPageTextSpanishDisabled,
        retToPageType: retToPageTypeDisabled,
        s3Id: s3IdDisabled,
        showCoupons: showCouponsDisabled,
        showLoyaltyReward: showLoyaltyRewardDisabled,
        siteName: siteNameDisabled,
        smartMatching: smartMatchingDisabled,
        // titleText: titleTextDisabled,
        titleSize: titleSizeDisabled,
        titleSizeM: titleSizeMDisabled,
        titleText: titleTextDisabled,
        titleTextSpanish: titleTextSpanishDisabled,
        titleType: titleTypeDisabled,
        tncSize: tncSizeDisabled,
        tncSizeM: tncSizeMDisabled,
        tncText: tncTextDisabled,
        tncTextSpanish: tncTextSpanishDisabled,
        tncType: tncTypeDisabled,
        // titleTypeM: titleTypeMDisabled,
        urgId: urgIdDisabled,
        jiSignUpUiBackgroundColor: jiSignUpUiBackgroundColorDisabled,
        jiSignUpUiFontColor: jiSignUpUiFontColorDisabled,
        kioskUiAdvDelaySec: kioskUiAdvDelaySecDisabled,
        kioskUiAdvWidth: kioskUiAdvWidthDisabled,
        kioskUiAdvHeight: kioskUiAdvHeightDisabled,
        kioskUiAdvTop: kioskUiAdvTopDisabled,
        kioskUiAdvBottom: kioskUiAdvBottomDisabled,
        kioskUiAllInOneCheckIn: kioskUiAllInOneCheckInDisabled,
        kioskUiBackgroundColor: kioskUiBackgroundColorDisabled,
        kioskUiButtonDisabledColor: kioskUiButtonDisabledColorDisabled,
        kioskUiButtonErrorColor: kioskUiButtonErrorColorDisabled,
        kioskUiButtonKeyColor: kioskUiButtonKeyColorDisabled,
        kioskUiButtonPrimaryColor: kioskUiButtonPrimaryColorDisabled,
        kioskUiButtonSuccessColor: kioskUiButtonSuccessColorDisabled,
        kioskUiContinueBtnTextColor: kioskUiContinueBtnTextColorDisabled,
        kioskUiHideAdvIn: kioskUiHideAdvInDisabled,
        kioskUiHideAdvOut: kioskUiHideAdvOutDisabled,
        kioskUiShowSigSmiley: kioskUiShowSigSmileyDisabled,
        kioskUiTabletView: kioskUiTabletViewDisabled,
        kioskUiSigHideAdvIn: kioskUiSigHideAdvInDisabled,
        kioskUiSigHideAdvOut: kioskUiSigHideAdvOutDisabled,
        kioskUiHideCity: kioskUiHideCityDisabled,
        kioskUiHideContBtn: kioskUiHideContBtnDisabled,
        // kioskUiHideDefaultWaiver: kioskUiHideDefaultWaiverDisabled,
        kioskUiLogoBorderColor: kioskUiLogoBorderColorDisabled,
        kioskUiLogoBorderEnable: kioskUiLogoBorderEnableDisabled,
        kioskUiLogoHeight: kioskUiLogoHeightDisabled,
        kioskUiLogoWidth: kioskUiLogoWidthDisabled,
        kioskUiTermTextColor: kioskUiTermTextColorDisabled,
        kioskUiTermTextSize: kioskUiTermTextSizeDisabled,
        kioskUiTextColor: kioskUiTextColorDisabled,
        kioskUiTextEngEditor: kioskUiTextEngEditorDisabled,
        kioskUiTextSpnEditor: kioskUiTextSpnEditorDisabled,
        kioskUiTitleTextColor: kioskUiTitleTextColorDisabled,
        kioskUiVehicleConfig: kioskUiVehicleConfigDisabled,
        kioskUiWaiverScroll: kioskUiWaiverScrollDisabled,
        spanishKeyword: spanishKeywordDisabled,
        spanishLocation: spanishLocationDisabled,
        spanishVipClubCheckboxText: spanishVipClubCheckboxTextDisabled,
        spanishVipClubHoverText: spanishVipClubHoverTextDisabled,
        widthForDesktop: widthForDesktopDisabled,
        widthForMobile: widthForMobileDisabled,
      },
    } = this.state;
    console.log(kioskUiTextEngEditorDisabled);
    console.log(kioskUiTextSpnEditorDisabled);
    const englishVipClubCheckboxTextDefault = "Want to join "+ this.state.businessName +" " + this.renderSiteName(this.props.site.path) + "'s VIP Club? Click here! ";
    const englishVipClubHoverTextDefault = this.state.businessName +" -REWARDS DONE RIGHT. "+ this.state.businessName +"'s VIP Members enjoy exclusive access to all things "+ this.state.businessName +". Members earn discounts on parts, free yard entries, "+ this.state.businessName +" merch, early yard access, and other automotive accessories - on us. Here at "+ this.state.businessName +", your parts are our priority! We understand your needs and work endlessly to make sure that we've got you covered. Joining our VIP Club is simple: sign up with your mobile number, enable text updates, and let the rewards come to you!";
    const spanishVipClubHoverTextDefault = this.state.businessName +" -REWARDS DONE RIGHT. "+ this.state.businessName +"'s VIP Members enjoy exclusive access to all things "+ this.state.businessName +". Members earn discounts on parts, free yard entries, "+ this.state.businessName +" merch, early yard access, and other automotive accessories - on us. Here at "+ this.state.businessName +", your parts are our priority! We understand your needs and work endlessly to make sure that we've got you covered. Joining our VIP Club is simple: sign up with your mobile number, enable text updates, and let the rewards come to you!";
    const spanishVipClubCheckboxTextDefault = "¿Quiere unirse al club VIP de "+ this.state.businessName +" " + this.renderSiteName(this.props.site.path) + "? ¡Haga clic aquí!";
    return (
      <>
        {isArchive === "1" ? (
          <Button intent="success" onClick={this.isArchiveSite("0")} style={{ marginBottom: "5px", width: "100px" }}>
            Restore
          </Button>
        ) : (
          <Button intent="danger" onClick={this.isArchiveSite("1")} style={{ marginBottom: "5px", width: "100px" }}>
            Archive
          </Button>
        )}

        <H3>options</H3>
        <FormGroup>
          <Switch
            checked={allowOptOut}
            disabled={allowOptOutDisabled}
            label="allow opt-out"
            name="allowOptOut"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={disableKeyboard}
            disabled={disableKeyboardDisabled}
            label="disable on-screen keyboard"
            name="disableKeyboard"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={noCheckIn}
            disabled={noCheckInDisabled}
            label="prevent opt-in"
            name="noCheckIn"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={showCoupons}
            disabled={showCouponsDisabled}
            label="show coupons button"
            name="showCoupons"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={showLoyaltyReward}
            disabled={showLoyaltyRewardDisabled}
            label="show loyalty reward"
            name="showLoyaltyReward"
            onChange={this.handleSwitchChange}
          />
          <FormGroup label="guid">
            <InputGroup
              disabled={guidDisabled}
              name="guid"
              value={guid || ""}
              inputRef={(ref) => (this.guidInput = ref)}
              onChange={this.handleTextChange}
              style={{ fontFamily: "monospace" }}
              rightElement={
                <Button
                  disabled={guidDisabled}
                  name="guid"
                  onClick={this.handleChangeButton}
                  value={guid || ""}
                  intent="primary"
                  minimal={true}
                >
                  change
                </Button>
              }
            />
          </FormGroup>

          <FormGroup label="ivision code">
            <InputGroup
              disabled={false}
              name="ivision code"
              value={shortcode || ""}
              onChange={this.handleShortcodeChange}
              style={{ fontFamily: "monospace" }}
              rightElement={
                <Button
                  disabled={shortcodeDisabled}
                  name="ivision code"
                  onClick={this.handleShortcodeChangeButton}
                  value={shortcode || ""}
                  intent="primary"
                  minimal={true}
                >
                  change
                </Button>
              }
            />
          </FormGroup>

          {/* <TextInputGroup
            disabled={false}
            name="ivision shortcode"
            onChange={this.handleShortcodeChange}
            onClick={this.handleShortcodeChangeButton}
            value={shortcode || ""}
          /> */}
          <TextInputGroup
            disabled={kioskNameDisabled}
            name="kioskName"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={kioskName || ""}
          />
          <TextInputGroup
            disabled={kioskNameEsDisabled}
            name="kioskNameEs"
            value={kioskNameEs || ""}
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
          />
          <TextInputGroup
            disabled={siteNameDisabled}
            name="siteName"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={siteName}
          />
          <H2>Just In Alerts Set up</H2>
          <TextInputGroup
            disabled={s3IdDisabled}
            name="s3Id"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={s3Id || ""}
          />
          <TextInputGroup
            disabled={urgIdDisabled}
            name="urgId"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={urgId || ""}
          />
          <H3>Just In Sign Up UI</H3>
          <Switch
            checked={smartMatching}
            disabled={smartMatchingDisabled}
            label="Smart Matching"
            name="smartMatching"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={enableExpanolBtn}
            disabled={enableExpanolBtnDisabled}
            label="Espanol Button Enable"
            name="enableExpanolBtn"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={enableRowInTxtMsg}
            disabled={enableRowInTxtMsgDisabled}
            label="Display The Row in Just In Text Message Enable"
            name="enableRowInTxtMsg"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={enableVipClub}
            disabled={enableVipClubDisabled}
            label="VIP Club Checkbox Enable"
            name="enableVipClub"
            onChange={this.handleSwitchChange}
          />
          <TextInputGroup
            disabled={englishKeywordDisabled}
            name="englishKeyword"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={englishKeyword || ""}
          />
          <TextInputGroup
            disabled={spanishKeywordDisabled}
            name="spanishKeyword"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={spanishKeyword || ""}
          />
          <TextInputGroup
            disabled={englishLocationDisabled}
            name="englishLocation"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={englishLocation || ""}
          />
          <TextInputGroup
            disabled={spanishLocationDisabled}
            name="spanishLocation"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={spanishLocation || ""}
          />

          <TextInputGroup
            disabled={englishVipClubCheckboxTextDisabled}
            name="englishVipClubCheckboxText"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={englishVipClubCheckboxText || englishVipClubCheckboxTextDefault}
          />
          <TextInputGroup
            disabled={spanishVipClubCheckboxTextDisabled}
            name="spanishVipClubCheckboxText"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={spanishVipClubCheckboxText || spanishVipClubCheckboxTextDefault}
          />
          <TextInputGroup
            disabled={englishVipClubHoverTextDisabled}
            name="englishVipClubHoverText"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={englishVipClubHoverText || englishVipClubHoverTextDefault}
          />
          <TextInputGroup
            disabled={spanishVipClubHoverTextDisabled}
            name="spanishVipClubHoverText"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={spanishVipClubHoverText || spanishVipClubHoverTextDefault}
          />
          <TextInputGroup
            disabled={homeBtnUrlDisabled}
            name="homeBtnUrl"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={homeBtnUrl || ""}
          />
          <H4>How It Works</H4>
          <H5>English</H5>
          <TextArea
            style={{ width: "100%", height: "200px" }}
            name="helpMenu"
            onChange={this.handleTextAreaChange}
            value={
              helpMenu ||
              "If you are returning to this page and want to check the vehicle picks you have already made, then enter your phone number it the bottom box below where it says “Returning to this page? Enter your mobile number to access Dashboard”.<br /><br /> If you haven’t ever entered a vehicle pick, then you will need to pick a Make and Model you want to receive notifications for.  Year range is optional.<br /><br /> Once you are finished entering the vehicle you want to receive notifications for, then enter a valid mobile number.<br /><br /> You can access your Dashboard with the green Next button.  Your Dashboard is where you can edit, renew or delete vehicle picks. "
            }
          />
          <div
            style={{
              background: "#144eeb",
              borderRadius: "5px",
              color: "#fff",
              cursor: "pointer",
              marginBottom: "10px",
              marginTop: "10px",
              padding: "4px 8px",
              width: "fit-content",
            }}
            onClick={() => this.handleChangeButtonForTextarea("helpMenu", helpMenu)}
          >
            Save
          </div>
          <H5>Spanish</H5>
          <TextArea
            style={{ width: "100%", height: "200px" }}
            name="helpMenus"
            onChange={this.handleTextAreaChange}
            value={
              helpMenus ||
              "Si regresa a esta página y desea verificar las selecciones de vehículos que ya realizó, ingrese su número de teléfono en el cuadro inferior donde dice “¿Regresando a esta página? Ingrese su número de teléfono móvil para acceder al Tablero ”.<br /><br />Si nunca ingresó una selección de vehículo, deberá elegir una Marca y Modelo para los que desea recibir notificaciones. El rango de años es opcional.<br /><br />Una vez que haya terminado de ingresar el vehículo para el que desea recibir notificaciones, ingrese un número de teléfono móvil válido.<br /><br />Puede acceder a su Panel de control con el botón verde Siguiente. Su Tablero es donde puede editar, renovar o eliminar selecciones de vehículos."
            }
          />
          <div
            style={{
              background: "#144eeb",
              borderRadius: "5px",
              color: "#fff",
              cursor: "pointer",
              marginTop: "10px",
              padding: "4px 8px",
              width: "fit-content",
            }}
            onClick={() => this.handleChangeButtonForTextarea("helpMenus", helpMenus)}
          >
            Save
          </div>
          <div style={{ marginTop: "10px" }}>
            <TextInputGroup
              disabled={howitworksTextDisabled}
              name="howitworksText"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={howitworksText || "How It Works"}
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <TextInputGroup
              disabled={howitworksTextsDisabled}
              name="howitworksTexts"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={howitworksTexts || "Cómo Funciona"}
            />
          </div>
          <div>
            {colorPickerOptions.howitworksColor ? (
              <TextInputGroupColor
                disabled={howitworksColorDisabled}
                name="howitworksColor"
                label="Font Color"
                onChange={this.handleTextChange}
                onClick={this.handleChangeButton}
                value={howitworksColor || "#fff"}
                colorPickerOptions={colorPickerOptions.howitworksColor}
                onClickPicker={this.onClickPicker}
                handleChangePicker={this.handleChangePicker}
              />
            ) : (
              ""
            )}
          </div>

          <div>
            {colorPickerOptions.howitworksBgColor ? (
              <TextInputGroupColor
                disabled={howitworksBgColorDisabled}
                name="howitworksBgColor"
                label="Background Color"
                onChange={this.handleTextChange}
                onClick={this.handleChangeButton}
                value={howitworksBgColor || "#0D47F0"}
                colorPickerOptions={colorPickerOptions.howitworksBgColor}
                onClickPicker={this.onClickPicker}
                handleChangePicker={this.handleChangePicker}
              />
            ) : (
              ""
            )}
          </div>

          <div style={{ marginBottom: "10px" }}>
            <label>Image : </label>
            <FileUploader
              accept="image/*"
              name="howitworksImg"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("how-it-works")}
              onUploadSuccess={this.handleHowItWorksUploadSuccess("howitworksImg")}
              // onUploadSuccess={this.handleUploadSuccess("kioskUiInAdvFile1")}
            />
            {howitworksImg ? (
              <>
                <img
                  src={howitworksImg}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveHowItWorks("howitworksImg")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>

          <H4>Home Button</H4>
          <Switch
            checked={homeBtnEnable}
            disabled={homeBtnEnableDisabled}
            label="Home Button Enable"
            name="homeBtnEnable"
            onChange={this.handleSwitchChange}
          />

          <div style={{ marginTop: "10px" }}>
            <TextInputGroup
              disabled={homeButtonTextDisabled}
              name="homeButtonText"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={homeButtonText || "Home"}
            />
          </div>
          <div style={{ marginTop: "10px" }}>
            <TextInputGroup
              disabled={homeButtonTextSpanishDisabled}
              name="homeButtonTextSpanish"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={homeButtonTextSpanish || "Hogar"}
            />
          </div>
          <div>
            {colorPickerOptions.homeButtonColor ? (
              <TextInputGroupColor
                disabled={homeButtonColorDisabled}
                name="homeButtonColor"
                label="Font Color"
                onChange={this.handleTextChange}
                onClick={this.handleChangeButton}
                value={homeButtonColor || "#fff"}
                colorPickerOptions={colorPickerOptions.homeButtonColor}
                onClickPicker={this.onClickPicker}
                handleChangePicker={this.handleChangePicker}
              />
            ) : (
              ""
            )}
          </div>

          <div>
            {colorPickerOptions.homeButtonBgColor ? (
              <TextInputGroupColor
                disabled={homeButtonBgColorDisabled}
                name="homeButtonBgColor"
                label="Background Color"
                onChange={this.handleTextChange}
                onClick={this.handleChangeButton}
                value={homeButtonBgColor || "#0D47F0"}
                colorPickerOptions={colorPickerOptions.homeButtonBgColor}
                onClickPicker={this.onClickPicker}
                handleChangePicker={this.handleChangePicker}
              />
            ) : (
              ""
            )}
          </div>

          <H4>Font Color</H4>
          {colorPickerOptions.jiSignUpUiBackgroundColor ? (
            <TextInputGroupColor
              disabled={jiSignUpUiBackgroundColorDisabled}
              name="jiSignUpUiBackgroundColor"
              label="Background Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={jiSignUpUiBackgroundColor || ""}
              colorPickerOptions={colorPickerOptions.jiSignUpUiBackgroundColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          {colorPickerOptions.jiSignUpUiFontColor ? (
            <TextInputGroupColor
              disabled={jiSignUpUiFontColorDisabled}
              name="jiSignUpUiFontColor"
              label="Font Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={jiSignUpUiFontColor || ""}
              colorPickerOptions={colorPickerOptions.jiSignUpUiFontColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          <H4>Logo</H4>
          <TextInputGroup
            disabled={widthForDesktopDisabled}
            name="widthForDesktop"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={widthForDesktop || "370px"}
          />
          <TextInputGroup
            disabled={widthForMobileDisabled}
            name="widthForMobile"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={widthForMobile || "370px"}
          />
          <TextInputGroup
            disabled={heightForDesktopDisabled}
            name="heightForDesktop"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={heightForDesktop || "130px"}
          />
          <TextInputGroup
            disabled={heightForMobileDisabled}
            name="heightForMobile"
            onChange={this.handleTextChange}
            onClick={this.handleChangeButton}
            value={heightForMobile || "130px"}
          />
          <H4>Title</H4>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Title Font Size for Desktop</label>
            <HTMLSelect
              disabled={titleSizeDisabled}
              fill={true}
              name="titleSize"
              onChange={this.handleSelect}
              options={this.sizeArray}
              value={titleSize || "28px"}
            />
          </div>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Title Font Size for Mobile</label>
            <HTMLSelect
              disabled={titleSizeMDisabled}
              fill={true}
              name="titleSizeM"
              onChange={this.handleSelect}
              options={this.sizeArray}
              value={titleSizeM || "28px"}
            />
          </div>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Title Font Type</label>
            <HTMLSelect
              disabled={titleTypeDisabled}
              fill={true}
              name="titleType"
              onChange={this.handleSelect}
              options={this.typeArray}
              value={titleType}
            />
          </div>
          <div style={{ marginBottom: "20px" }}>
            {/* <label style={{marginBottom:"10px"}}>Title Text</label> */}
            <TextInputGroup
              disabled={titleTextDisabled}
              name="titleText"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={titleText || "Just In vehicle alerts at "}
              // value={titleText || "Sign up for Just In vehicle alerts at "}
            />
            <TextInputGroup
              disabled={titleTextSpanishDisabled}
              name="titleTextSpanish"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={titleTextSpanish || "Regístrese para recibir alertas de texto de Fresh Stock en "}
            />
          </div>
          <H4>Returning to this page? Customization</H4>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Font Size for Desktop</label>
            <HTMLSelect
              disabled={retToPageSizeDisabled}
              fill={true}
              name="retToPageSize"
              onChange={this.handleSelect}
              options={this.sizeArray}
              value={retToPageSize || "28px"}
            />
          </div>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Font Size for Mobile</label>
            <HTMLSelect
              disabled={retToPageSizeMDisabled}
              fill={true}
              name="retToPageSizeM"
              onChange={this.handleSelect}
              options={this.sizeArray}
              value={retToPageSizeM || "28px"}
            />
          </div>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Font Type</label>
            <HTMLSelect
              disabled={retToPageTypeDisabled}
              fill={true}
              name="retToPageType"
              onChange={this.handleSelect}
              options={this.typeArray}
              value={retToPageType}
            />
          </div>
          <div style={{ marginBottom: "20px" }}>
            {/* <label style={{marginBottom:"10px"}}>Title Text</label> */}
            <TextInputGroup
              disabled={retToPageTextDisabled}
              name="retToPageText"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={retToPageText || "Returning to this page?"}
            />
            <TextInputGroup
              disabled={retToPageTextSpanishDisabled}
              name="retToPageTextSpanish"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={retToPageTextSpanish || "Ingrese su número de teléfono móvil"}
            />
          </div>
          <H4>Enter your mobile number to access Dashboard</H4>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Font Size for Desktop</label>
            <HTMLSelect
              disabled={accessDashboardSizeDisabled}
              fill={true}
              name="accessDashboardSize"
              onChange={this.handleSelect}
              options={this.sizeArray}
              value={accessDashboardSize || "21px"}
            />
          </div>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Font Size for Mobile</label>
            <HTMLSelect
              disabled={accessDashboardSizeMDisabled}
              fill={true}
              name="accessDashboardSizeM"
              onChange={this.handleSelect}
              options={this.sizeArray}
              value={accessDashboardSizeM || "21px"}
            />
          </div>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Font Type</label>
            <HTMLSelect
              disabled={accessDashboardTypeDisabled}
              fill={true}
              name="accessDashboardType"
              onChange={this.handleSelect}
              options={this.typeArray}
              value={accessDashboardType}
            />
          </div>
          <div style={{ marginBottom: "20px" }}>
            {/* <label style={{marginBottom:"10px"}}>Title Text</label> */}
            <TextInputGroup
              disabled={accessDashboardTextDisabled}
              name="accessDashboardText"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={accessDashboardText || "Enter your mobile number to access Dashboard"}
            />
            <TextInputGroup
              disabled={accessDashboardTextSpanishDisabled}
              name="accessDashboardTextSpanish"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={accessDashboardTextSpanish || "Ingrese su número de teléfono móvil"}
            />
            <Switch
              checked={enableItalic}
              disabled={enableItalicDisabled}
              label="Enable Italic"
              name="enableItalic"
              onChange={this.handleSwitchChange}
            />
          </div>
          <H4>Description</H4>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Description Font Size for Desktop</label>
            <HTMLSelect
              disabled={descSizeDisabled}
              fill={true}
              name="descSize"
              onChange={this.handleSelect}
              options={this.sizeArray}
              value={descSize || "19px"}
            />
          </div>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Description Font Size for Mobile</label>
            <HTMLSelect
              disabled={descSizeMDisabled}
              fill={true}
              name="descSizeM"
              onChange={this.handleSelect}
              options={this.sizeArray}
              value={descSizeM || "19px"}
            />
          </div>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Description Font Type</label>
            <HTMLSelect
              disabled={descTypeDisabled}
              fill={true}
              name="descType"
              onChange={this.handleSelect}
              options={this.typeArray}
              value={descType}
            />
          </div>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <TextInputGroup
              disabled={descTextDisabled}
              name="descText"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={descText || "Get Alerts for newly-added vehicles, "}
            />
            <TextInputGroup
              disabled={descTextSecondlineDisabled}
              name="descTextSecondline"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={descTextSecondline || "Straight to your phone! We'll send you a text when it arrives."}
            />
            <TextInputGroup
              disabled={descTextSpanishDisabled}
              name="descTextSpanish"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={descTextSpanish || "Regístrese para recibir alertas de texto de Fresh Stock en "}
            />
            <TextInputGroup
              disabled={descTextSpanishSecondlineDisabled}
              name="descTextSpanishSecondline"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={
                descTextSpanishSecondline || "Directo a su teléfono! Le enviaremos un mensaje de texto cuando llegue"
              }
            />
          </div>
          <H4>Terms And Conditions</H4>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Font Size for Desktop</label>
            <HTMLSelect
              disabled={tncSizeDisabled}
              fill={true}
              name="tncSize"
              onChange={this.handleSelect}
              options={this.sizeArray}
              value={tncSize || "14px"}
            />
          </div>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Font Size for Mobile</label>
            <HTMLSelect
              disabled={tncSizeMDisabled}
              fill={true}
              name="tncSizeM"
              onChange={this.handleSelect}
              options={this.sizeArray}
              value={tncSizeM || "14px"}
            />
          </div>
          <div style={{ marginBottom: "20px" }} className={"signup_up_ui"}>
            <label style={{ marginBottom: "10px" }}>Font Type</label>
            <HTMLSelect
              disabled={tncTypeDisabled}
              fill={true}
              name="tncType"
              onChange={this.handleSelect}
              options={this.typeArray}
              value={tncType}
            />
          </div>
          <div style={{ marginBottom: "20px" }}>
            <TextInputGroup
              disabled={tncTextDisabled}
              name="tncText"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={
                tncText ||
                "By selecting Next, you are signing up to receive automated text alerts and marketing calls from an autodialer system or live person. Consent to receive automated text alerts not required for purchase. Upon completion of this form, you will receive a text message with instructions to confirm your opt-in. Approx 31 msg/mo & Data Rates May Apply. Reply HELP for HELP, STOP ALL to cancel."
              }
            />
            <TextInputGroup
              disabled={tncTextSpanishDisabled}
              name="tncTextSpanish"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={
                tncTextSpanish ||
                "Al seleccionar Siguiente, se registra para recibir alertas de texto automatizadas y llamadas de marketing de un sistema de marcación automática o una persona en vivo. No se requiere consentimiento para recibir alertas de texto automáticas para la compra. Al completar este formulario, recibirá un mensaje de texto con instrucciones para confirmar su suscripción. Se pueden aplicar hasta 31 msg / mes y tarifas de datos. Responda HELP para HELP, STOP ALL para cancelar."
              }
            />
          </div>
          <H3>Kiosk UI</H3>
          {colorPickerOptions.kioskUiBackgroundColor ? (
            <TextInputGroupColor
              disabled={kioskUiBackgroundColorDisabled}
              name="kioskUiBackgroundColor"
              label="Background Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={kioskUiBackgroundColor || ""}
              colorPickerOptions={colorPickerOptions.kioskUiBackgroundColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          {colorPickerOptions.kioskUiButtonPrimaryColor ? (
            <TextInputGroupColor
              disabled={kioskUiButtonPrimaryColorDisabled}
              name="kioskUiButtonPrimaryColor"
              label="Primary Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={kioskUiButtonPrimaryColor || ""}
              colorPickerOptions={colorPickerOptions.kioskUiButtonPrimaryColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          {colorPickerOptions.kioskUiTextColor ? (
            <TextInputGroupColor
              disabled={kioskUiTextColorDisabled}
              name="kioskUiTextColor"
              label="Secondary Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={kioskUiTextColor || ""}
              colorPickerOptions={colorPickerOptions.kioskUiTextColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          {colorPickerOptions.kioskUiButtonErrorColor ? (
            <TextInputGroupColor
              disabled={kioskUiButtonErrorColorDisabled}
              name="kioskUiButtonErrorColor"
              label="Error Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={kioskUiButtonErrorColor || ""}
              colorPickerOptions={colorPickerOptions.kioskUiButtonErrorColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          {colorPickerOptions.kioskUiButtonDisabledColor ? (
            <TextInputGroupColor
              disabled={kioskUiButtonDisabledColorDisabled}
              name="kioskUiButtonDisabledColor"
              label="Button Disabled Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={kioskUiButtonDisabledColor || ""}
              colorPickerOptions={colorPickerOptions.kioskUiButtonDisabledColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          {colorPickerOptions.kioskUiButtonSuccessColor ? (
            <TextInputGroupColor
              disabled={kioskUiButtonSuccessColorDisabled}
              name="kioskUiButtonSuccessColor"
              label="Success Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={kioskUiButtonSuccessColor || ""}
              colorPickerOptions={colorPickerOptions.kioskUiButtonSuccessColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          {colorPickerOptions.kioskUiButtonKeyColor ? (
            <TextInputGroupColor
              disabled={kioskUiButtonKeyColorDisabled}
              name="kioskUiButtonKeyColor"
              label="Button Keypad Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={kioskUiButtonKeyColor || ""}
              colorPickerOptions={colorPickerOptions.kioskUiButtonKeyColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          {colorPickerOptions.kioskUiTermTextColor ? (
            <TextInputGroupColor
              disabled={kioskUiTermTextColorDisabled}
              name="kioskUiTermTextColor"
              label="Term Text Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={kioskUiTermTextColor || ""}
              colorPickerOptions={colorPickerOptions.kioskUiTermTextColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          {colorPickerOptions.kioskUiTitleTextColor ? (
            <TextInputGroupColor
              disabled={kioskUiTitleTextColorDisabled}
              name="kioskUiTitleTextColor"
              label="Title Text Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={kioskUiTitleTextColor || ""}
              colorPickerOptions={colorPickerOptions.kioskUiTitleTextColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          {colorPickerOptions.kioskUiContinueBtnTextColor ? (
            <TextInputGroupColor
              disabled={kioskUiContinueBtnTextColorDisabled}
              name="kioskUiContinueBtnTextColor"
              label="Continue Button Text Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={kioskUiContinueBtnTextColor || ""}
              colorPickerOptions={colorPickerOptions.kioskUiContinueBtnTextColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          <Switch
            checked={kioskUiLogoBorderEnable}
            disabled={kioskUiLogoBorderEnableDisabled}
            label="Enable Logo Border"
            name="kioskUiLogoBorderEnable"
            onChange={this.handleSwitchChange}
          />
          {colorPickerOptions.kioskUiLogoBorderColor ? (
            <TextInputGroupColor
              disabled={kioskUiLogoBorderColorDisabled}
              name="kioskUiLogoBorderColor"
              label="Logo Border Color"
              onChange={this.handleTextChange}
              onClick={this.handleChangeButton}
              value={kioskUiLogoBorderColor || ""}
              colorPickerOptions={colorPickerOptions.kioskUiLogoBorderColor}
              onClickPicker={this.onClickPicker}
              handleChangePicker={this.handleChangePicker}
            />
          ) : (
            ""
          )}
          <div style={{ marginBottom: "10px" }}>
            <label>Term Font Size</label>
            <HTMLSelect
              disabled={kioskUiTermTextSizeDisabled}
              fill={true}
              name="kioskUiTermTextSize"
              onChange={this.handleSelect}
              options={this.sizeArray}
              value={kioskUiTermTextSize || "10px"}
            />
          </div>
          <Switch
            checked={kioskUiHideCity}
            disabled={kioskUiHideCityDisabled}
            label="Hide city name"
            name="kioskUiHideCity"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={kioskUiShowSigSmiley}
            disabled={kioskUiShowSigSmileyDisabled}
            label="Show Smiley In Signature Page"
            name="kioskUiShowSigSmiley"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={kioskUiHideContBtn}
            disabled={kioskUiHideContBtnDisabled}
            label="Hide continue buttons until phone number complete"
            name="kioskUiHideContBtn"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={kioskUiWaiverScroll}
            disabled={kioskUiWaiverScrollDisabled}
            label="Enable Waiver Scroll Feature"
            name="kioskUiWaiverScroll"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={kioskUiTabletView}
            disabled={kioskUiTabletViewDisabled}
            label="Check-In Page on Tablet"
            name="kioskUiTabletView"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={kioskUiVehicleConfig}
            disabled={kioskUiVehicleConfigDisabled}
            label="Vehicle Kiosk Configuration"
            name="kioskUiVehicleConfig"
            onChange={this.handleSwitchChange}
          />
          <Switch
            checked={kioskUiAllInOneCheckIn}
            disabled={kioskUiAllInOneCheckInDisabled}
            label="All-In-One Check-In with Advertisements configuration"
            name="kioskUiAllInOneCheckIn"
            onChange={this.handleSwitchChange}
          />
          {/* <Switch
            checked={kioskUiHideDefaultWaiver}
            disabled={kioskUiHideDefaultWaiverDisabled}
            label="Interactive Waiver"
            name="kioskUiHideDefaultWaiver"
            onChange={this.handleSwitchChange}
          />
          {kioskUiHideDefaultWaiver?(
            <Editor
              onInit={(evt, editor) => this.setState({ tinyEngEditor : editor })}
              initialValue={"<div id='eng_editor'>"+kioskUiTextEngEditor+"</div>"}
              // initialValue="<div id='eng_editor'>"{kioskUiTextEngEditor}"</div>"
              init={{
                content_style: '#eng_editor { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                height: 500,
                menubar: false,
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount'
                ],
                toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl | table',
                width: 700,
                
              }}
            />            
          )
          :''}
          {kioskUiHideDefaultWaiver?(
            <div>
              <Button onClick={this.saveEngEditorData} intent="primary" style={{ marginTop:'10px', marginBottom:'10px' }}>Save English Editor</Button>
            </div>            
          )
          :''}
          {kioskUiHideDefaultWaiver?(
            <Editor
              onInit={(evt, editor) => this.setState({ tinySpnEditor : editor })}
              initialValue={"<div id='eng_editor'>"+kioskUiTextSpnEditor+"</div>"}
              // initialValue="<div id='eng_editor'>"{kioskUiTextSpnEditor}"</div>"
              init={{
                content_style: '#eng_editor { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                height: 500,
                menubar: false,
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount'
                ],
                toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl | table',
                
              }}
            />            
          )
          :''}
          {kioskUiHideDefaultWaiver?(
            <div>
              <Button onClick={this.saveSpnEditorData} intent="primary" style={{ marginTop:'10px', marginBottom:'10px' }}>Save Spanish Editor</Button>
            </div>            
          )
          :''} */}
          {/* <Editor
            onInit={(evt, editor) => this.setState({ tinyEngEditor : editor })}
            initialValue={"<div id='eng_editor'>"+kioskUiTextEngEditor+"</div>"}
            // initialValue="<div id='eng_editor'>"{kioskUiTextEngEditor}"</div>"
            init={{
              content_style: '#eng_editor { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
              height: 500,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount'
              ],
              toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl | table',
              width: 700,
              
            }}
          />
          <div>
            <Button onClick={this.saveEngEditorData} intent="primary" style={{ marginTop:'10px', marginBottom:'10px' }}>Save English Editor</Button>
          </div>
          <Editor
            onInit={(evt, editor) => this.setState({ tinySpnEditor : editor })}
            initialValue={"<div id='eng_editor'>"+kioskUiTextSpnEditor+"</div>"}
            // initialValue="<div id='eng_editor'>"{kioskUiTextSpnEditor}"</div>"
            init={{
              content_style: '#eng_editor { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
              height: 500,
              menubar: false,
              plugins: [
                'advlist autolink lists link image charmap print preview anchor',
                'searchreplace visualblocks code fullscreen',
                'insertdatetime media table paste code help wordcount'
              ],
              toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl | table',
              
            }}
          />
          <div>
            <Button onClick={this.saveSpnEditorData} intent="primary" style={{ marginTop:'10px', marginBottom:'10px' }}>Save Spanish Editor</Button>
          </div> */}
          <FormGroup label="Advertising Width">
            <InputGroup
              disabled={kioskUiAdvWidthDisabled}
              name="kioskUiAdvWidth"
              value={kioskUiAdvWidth || ""}
              onChange={this.handleTextChange}
              style={{ fontFamily: "monospace" }}
              rightElement={
                <Button
                  disabled={kioskUiAdvWidthDisabled}
                  name="kioskUiAdvWidth"
                  onClick={this.handleChangeButton}
                  value={kioskUiAdvWidth || ""}
                  intent="primary"
                  minimal={true}
                >
                  change
                </Button>
              }
            />
          </FormGroup>
          <FormGroup label="Advertising Height">
            <InputGroup
              disabled={kioskUiAdvHeightDisabled}
              name="kioskUiAdvHeight"
              value={kioskUiAdvHeight || ""}
              onChange={this.handleTextChange}
              style={{ fontFamily: "monospace" }}
              rightElement={
                <Button
                  disabled={kioskUiAdvHeightDisabled}
                  name="kioskUiAdvHeight"
                  onClick={this.handleChangeButton}
                  value={kioskUiAdvHeight || ""}
                  intent="primary"
                  minimal={true}
                >
                  change
                </Button>
              }
            />
          </FormGroup>
          <FormGroup label="Advertising Margin Top">
            <InputGroup
              disabled={kioskUiAdvTopDisabled}
              name="kioskUiAdvTop"
              value={kioskUiAdvTop || ""}
              onChange={this.handleTextChange}
              style={{ fontFamily: "monospace" }}
              rightElement={
                <Button
                  disabled={kioskUiAdvTopDisabled}
                  name="kioskUiAdvTop"
                  onClick={this.handleChangeButton}
                  value={kioskUiAdvTop || ""}
                  intent="primary"
                  minimal={true}
                >
                  change
                </Button>
              }
            />
          </FormGroup>
          <FormGroup label="Advertising Margin Bottom">
            <InputGroup
              disabled={kioskUiAdvBottomDisabled}
              name="kioskUiAdvBottom"
              value={kioskUiAdvBottom || ""}
              onChange={this.handleTextChange}
              style={{ fontFamily: "monospace" }}
              rightElement={
                <Button
                  disabled={kioskUiAdvBottomDisabled}
                  name="kioskUiAdvBottom"
                  onClick={this.handleChangeButton}
                  value={kioskUiAdvBottom || ""}
                  intent="primary"
                  minimal={true}
                >
                  change
                </Button>
              }
            />
          </FormGroup>
          <FormGroup label="Kiosk Logo Width">
            <InputGroup
              disabled={kioskUiLogoWidthDisabled}
              name="kioskUiLogoWidth"
              value={kioskUiLogoWidth || ""}
              onChange={this.handleTextChange}
              style={{ fontFamily: "monospace" }}
              rightElement={
                <Button
                  disabled={kioskUiLogoWidthDisabled}
                  name="kioskUiLogoWidth"
                  onClick={this.handleChangeButton}
                  value={kioskUiLogoWidth || ""}
                  intent="primary"
                  minimal={true}
                >
                  change
                </Button>
              }
            />
          </FormGroup>
          <FormGroup label="Kiosk Logo Height">
            <InputGroup
              disabled={kioskUiLogoHeightDisabled}
              name="kioskUiLogoHeight"
              value={kioskUiLogoHeight || ""}
              onChange={this.handleTextChange}
              style={{ fontFamily: "monospace" }}
              rightElement={
                <Button
                  disabled={kioskUiLogoHeightDisabled}
                  name="kioskUiLogoHeight"
                  onClick={this.handleChangeButton}
                  value={kioskUiLogoHeight || ""}
                  intent="primary"
                  minimal={true}
                >
                  change
                </Button>
              }
            />
          </FormGroup>
          <div style={{ marginBottom: "10px" }}>
            <label>Advertising Slide Delay Second</label>
            <HTMLSelect
              disabled={kioskUiAdvDelaySecDisabled}
              fill={true}
              name="kioskUiAdvDelaySec"
              onChange={this.handleSelect}
              options={this.delaySecondArray}
              value={kioskUiAdvDelaySec || "10px"}
            />
          </div>
          <H3 style={{ marginBottom: "10px", marginTop: "10px" }}>Kiosk Inside Advertising</H3>
          <Switch
            checked={kioskUiHideAdvIn}
            disabled={kioskUiHideAdvInDisabled}
            label="Hide Slider"
            name="kioskUiHideAdvIn"
            onChange={this.handleSwitchChange}
          />
          <div style={{ marginBottom: "10px" }}>
            <label>File 1: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiInAdvFile1"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiInAdvFile1")}
            />
            {kioskUiInAdvFile1 ? (
              <>
                <img
                  src={kioskUiInAdvFile1}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiInAdvFile1")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 2: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiInAdvFile2"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiInAdvFile2")}
            />
            {kioskUiInAdvFile2 ? (
              <>
                <img
                  src={kioskUiInAdvFile2}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiInAdvFile2")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 3: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiInAdvFile3"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiInAdvFile3")}
            />
            {kioskUiInAdvFile3 ? (
              <>
                <img
                  src={kioskUiInAdvFile3}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiInAdvFile3")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 4: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiInAdvFile4"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiInAdvFile4")}
            />
            {kioskUiInAdvFile4 ? (
              <>
                <img
                  src={kioskUiInAdvFile4}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiInAdvFile4")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 5: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiInAdvFile5"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiInAdvFile5")}
            />
            {kioskUiInAdvFile5 ? (
              <>
                <img
                  src={kioskUiInAdvFile5}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiInAdvFile5")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 6: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiInAdvFile6"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiInAdvFile6")}
            />
            {kioskUiInAdvFile6 ? (
              <>
                <img
                  src={kioskUiInAdvFile6}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiInAdvFile6")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 7: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiInAdvFile7"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiInAdvFile7")}
            />
            {kioskUiInAdvFile7 ? (
              <>
                <img
                  src={kioskUiInAdvFile7}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiInAdvFile7")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 8: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiInAdvFile8"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiInAdvFile8")}
            />
            {kioskUiInAdvFile8 ? (
              <>
                <img
                  src={kioskUiInAdvFile8}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiInAdvFile8")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 9: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiInAdvFile9"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiInAdvFile9")}
            />
            {kioskUiInAdvFile9 ? (
              <>
                <img
                  src={kioskUiInAdvFile9}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiInAdvFile9")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 10: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiInAdvFile10"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiInAdvFile10")}
            />
            {kioskUiInAdvFile10 ? (
              <>
                <img
                  src={kioskUiInAdvFile10}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiInAdvFile10")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <H3 style={{ marginBottom: "10px", marginTop: "10px" }}>Kiosk Outside Advertising</H3>
          <Switch
            checked={kioskUiHideAdvOut}
            disabled={kioskUiHideAdvOutDisabled}
            label="Hide Slider"
            name="kioskUiHideAdvOut"
            onChange={this.handleSwitchChange}
          />
          <div style={{ marginBottom: "10px" }}>
            <label>File 1: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiOutAdvFile1"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiOutAdvFile1")}
            />
            {kioskUiOutAdvFile1 ? (
              <>
                <img
                  src={kioskUiOutAdvFile1}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiOutAdvFile1")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 2: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiOutAdvFile2"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiOutAdvFile2")}
            />
            {kioskUiOutAdvFile2 ? (
              <>
                <img
                  src={kioskUiOutAdvFile2}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiOutAdvFile2")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 3: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiOutAdvFile3"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiOutAdvFile3")}
            />
            {kioskUiOutAdvFile3 ? (
              <>
                <img
                  src={kioskUiOutAdvFile3}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiOutAdvFile3")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 4: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiOutAdvFile4"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiOutAdvFile4")}
            />
            {kioskUiOutAdvFile4 ? (
              <>
                <img
                  src={kioskUiOutAdvFile4}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiOutAdvFile4")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 5: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiOutAdvFile5"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiOutAdvFile5")}
            />
            {kioskUiOutAdvFile5 ? (
              <>
                <img
                  src={kioskUiOutAdvFile5}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiOutAdvFile5")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 6: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiOutAdvFile6"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiOutAdvFile6")}
            />
            {kioskUiOutAdvFile6 ? (
              <>
                <img
                  src={kioskUiOutAdvFile6}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiOutAdvFile6")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 7: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiOutAdvFile7"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiOutAdvFile7")}
            />
            {kioskUiOutAdvFile7 ? (
              <>
                <img
                  src={kioskUiOutAdvFile7}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiOutAdvFile7")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 8: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiOutAdvFile8"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiOutAdvFile8")}
            />
            {kioskUiOutAdvFile8 ? (
              <>
                <img
                  src={kioskUiOutAdvFile8}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiOutAdvFile8")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 9: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiOutAdvFile9"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiOutAdvFile9")}
            />
            {kioskUiOutAdvFile9 ? (
              <>
                <img
                  src={kioskUiOutAdvFile9}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiOutAdvFile9")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 10: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiOutAdvFile10"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiOutAdvFile10")}
            />
            {kioskUiOutAdvFile10 ? (
              <>
                <img
                  src={kioskUiOutAdvFile10}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiOutAdvFile10")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <H3 style={{ marginBottom: "10px", marginTop: "10px" }}>Kiosk Signature Inside Advertising</H3>
          <Switch
            checked={kioskUiSigHideAdvIn}
            disabled={kioskUiSigHideAdvInDisabled}
            label="Hide Slider"
            name="kioskUiSigHideAdvIn"
            onChange={this.handleSwitchChange}
          />
          <div style={{ marginBottom: "10px" }}>
            <label>File 1: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigInAdvFile1"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigInAdvFile1")}
            />
            {kioskUiSigInAdvFile1 ? (
              <>
                <img
                  src={kioskUiSigInAdvFile1}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigInAdvFile1")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 2: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigInAdvFile2"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigInAdvFile2")}
            />
            {kioskUiSigInAdvFile2 ? (
              <>
                <img
                  src={kioskUiSigInAdvFile2}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigInAdvFile2")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 3: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigInAdvFile3"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigInAdvFile3")}
            />
            {kioskUiSigInAdvFile3 ? (
              <>
                <img
                  src={kioskUiSigInAdvFile3}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigInAdvFile3")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 4: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigInAdvFile4"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigInAdvFile4")}
            />
            {kioskUiSigInAdvFile4 ? (
              <>
                <img
                  src={kioskUiSigInAdvFile4}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigInAdvFile4")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 5: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigInAdvFile5"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigInAdvFile5")}
            />
            {kioskUiSigInAdvFile5 ? (
              <>
                <img
                  src={kioskUiSigInAdvFile5}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigInAdvFile5")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 6: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigInAdvFile6"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigInAdvFile6")}
            />
            {kioskUiSigInAdvFile6 ? (
              <>
                <img
                  src={kioskUiSigInAdvFile6}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigInAdvFile6")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 7: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigInAdvFile7"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigInAdvFile7")}
            />
            {kioskUiSigInAdvFile7 ? (
              <>
                <img
                  src={kioskUiSigInAdvFile7}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigInAdvFile7")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 8: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigInAdvFile8"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigInAdvFile8")}
            />
            {kioskUiSigInAdvFile8 ? (
              <>
                <img
                  src={kioskUiSigInAdvFile8}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigInAdvFile8")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 9: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigInAdvFile9"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigInAdvFile9")}
            />
            {kioskUiSigInAdvFile9 ? (
              <>
                <img
                  src={kioskUiSigInAdvFile9}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigInAdvFile9")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 10: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigInAdvFile10"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigInAdvFile10")}
            />
            {kioskUiSigInAdvFile10 ? (
              <>
                <img
                  src={kioskUiSigInAdvFile10}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigInAdvFile10")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <H3 style={{ marginBottom: "10px", marginTop: "10px" }}>Kiosk Signature Outside Advertising</H3>
          <Switch
            checked={kioskUiSigHideAdvOut}
            disabled={kioskUiSigHideAdvOutDisabled}
            label="Hide Slider"
            name="kioskUiSigHideAdvOut"
            onChange={this.handleSwitchChange}
          />
          <div style={{ marginBottom: "10px" }}>
            <label>File 1: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigOutAdvFile1"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigOutAdvFile1")}
            />
            {kioskUiSigOutAdvFile1 ? (
              <>
                <img
                  src={kioskUiSigOutAdvFile1}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigOutAdvFile1")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 2: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigOutAdvFile2"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigOutAdvFile2")}
            />
            {kioskUiSigOutAdvFile2 ? (
              <>
                <img
                  src={kioskUiSigOutAdvFile2}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigOutAdvFile2")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 3: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigOutAdvFile3"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigOutAdvFile3")}
            />
            {kioskUiSigOutAdvFile3 ? (
              <>
                <img
                  src={kioskUiSigOutAdvFile3}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigOutAdvFile3")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 4: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigOutAdvFile4"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigOutAdvFile4")}
            />
            {kioskUiSigOutAdvFile4 ? (
              <>
                <img
                  src={kioskUiSigOutAdvFile4}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigOutAdvFile4")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 5: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigOutAdvFile5"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigOutAdvFile5")}
            />
            {kioskUiSigOutAdvFile5 ? (
              <>
                <img
                  src={kioskUiSigOutAdvFile5}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigOutAdvFile5")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 6: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigOutAdvFile6"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigOutAdvFile6")}
            />
            {kioskUiSigOutAdvFile6 ? (
              <>
                <img
                  src={kioskUiSigOutAdvFile6}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigOutAdvFile6")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 7: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigOutAdvFile7"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigOutAdvFile7")}
            />
            {kioskUiSigOutAdvFile7 ? (
              <>
                <img
                  src={kioskUiSigOutAdvFile7}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigOutAdvFile7")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 8: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigOutAdvFile8"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigOutAdvFile8")}
            />
            {kioskUiSigOutAdvFile8 ? (
              <>
                <img
                  src={kioskUiSigOutAdvFile8}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigOutAdvFile8")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 9: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigOutAdvFile9"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigOutAdvFile9")}
            />
            {kioskUiSigOutAdvFile9 ? (
              <>
                <img
                  src={kioskUiSigOutAdvFile9}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigOutAdvFile9")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
          <div style={{ marginBottom: "10px" }}>
            <label>File 10: </label>
            <FileUploader
              accept="image/*"
              name="kioskUiSigOutAdvFile10"
              randomizeFilename={false}
              storageRef={firebase.storage().ref("kiosk-inside-advertising")}
              onUploadSuccess={this.handleUploadSuccess("kioskUiSigOutAdvFile10")}
            />
            {kioskUiSigOutAdvFile10 ? (
              <>
                <img
                  src={kioskUiSigOutAdvFile10}
                  style={{
                    height: "70px",
                    marginRight: "5px",
                    objectFit: "cover",
                    verticalAlign: "middle",
                    width: "70px",
                  }}
                />
                <a
                  href={void 0}
                  style={{
                    color: "red",
                    fontWeight: "bold",
                  }}
                  onClick={() => this.handleRemoveAdvUrl("kioskUiSigOutAdvFile10")}
                >
                  Remove
                </a>
              </>
            ) : (
              ""
            )}
          </div>
        </FormGroup>
      </>
    );
  }

  private saveShortcode = async (shortcode: string) => {
    const { businessId } = this.props;
    const bData = await updateShortcode({ businessId, shortcode });
    console.log(bData);
  };
  private getBusinessData = async () => {
    const { businessId } = this.props;

    const bData = await getBusinessData({ businessId });
    if (bData.shortcode) {
      console.log("........................................");
      console.log(bData);

      this.setState({ shortcode: bData.shortcode });
    }
    if(bData.businessName){
      this.setState({ businessName : bData.businessName });
    }
  };

  private initInputMask = () => {
    this.guidInterval = window.setInterval(() => {
      if (this.guidInput) {
        this.setInputMask();
        window.clearInterval(this.guidInterval);
      }
    });
  };

  private setInputMask = () => {
    this.guidInputMask = new InputMask(this.guidInput, {
      definitions: {
        "@": /[a-zA-Z0-9]/,
      },
      lazy: true,
      mask: "\\{@@@@@@@@-@@@@-@@@@-@@@@-@@@@@@@@@@@@\\}",
      placeholderChar: " ",
    });
  };

  private buildSiteOptions = () => {
    const { site } = this.props;
    const siteOptions: Businesses.SiteOptions = {
      accessDashboardSize: "",
      accessDashboardSizeM: "",
      accessDashboardText: "",
      accessDashboardTextSpanish: "",
      accessDashboardType: "",
      allowOptOut: false,
      descSize: "",
      descSizeM: "",
      descText: "",
      descTextSecondline: "",
      descTextSpanish: "",
      descTextSpanishSecondline: "",
      descType: "",
      // descTypeM: "",
      disableKeyboard: false,
      enableExpanolBtn: true,
      enableItalic: true,
      enableRowInTxtMsg: false,
      enableVipClub: false,
      englishKeyword: "",
      englishLocation: "",
      englishVipClubCheckboxText: "",
      englishVipClubHoverText: "",
      guid: null,
      heightForDesktop: "",
      heightForMobile: "",
      helpMenu: "",
      helpMenus: "",
      homeBtnEnable: false,
      homeBtnUrl: "",
      homeButtonBgColor: "",
      homeButtonColor: "",
      homeButtonText: "",
      homeButtonTextSpanish: "",
      howitworksBgColor: "",
      howitworksColor: "",
      howitworksImg: "",
      howitworksText: "",
      howitworksTexts: "",
      isArchive: "0",
      jiSignUpUiBackgroundColor: "",
      jiSignUpUiFontColor: "",
      kioskName: "",
      kioskNameEs: null,
      kioskUiAdvBottom: "",
      kioskUiAdvDelaySec: "",
      kioskUiAdvHeight: "",
      kioskUiAdvTop: "",
      kioskUiAdvWidth: "",
      kioskUiAllInOneCheckIn:false,
      kioskUiBackgroundColor: "",
      kioskUiButtonDisabledColor: "",
      kioskUiButtonErrorColor: "",
      kioskUiButtonKeyColor: "",
      kioskUiButtonPrimaryColor: "",
      kioskUiButtonSuccessColor: "",
      kioskUiContinueBtnTextColor: "",
      kioskUiHideAdvIn: true,
      kioskUiHideAdvOut: true,
      kioskUiHideCity: false,
      kioskUiHideContBtn: false,
      kioskUiHideDefaultWaiver: false,
      kioskUiInAdvFile1: "",
      kioskUiInAdvFile10: "",
      kioskUiInAdvFile2: "",
      kioskUiInAdvFile3: "",
      kioskUiInAdvFile4: "",
      kioskUiInAdvFile5: "",
      kioskUiInAdvFile6: "",
      kioskUiInAdvFile7: "",
      kioskUiInAdvFile8: "",
      kioskUiInAdvFile9: "",
      kioskUiLogoBorderColor: "",
      kioskUiLogoBorderEnable: false,
      kioskUiLogoHeight: "",
      kioskUiLogoWidth: "",
      kioskUiOutAdvFile1: "",
      kioskUiOutAdvFile10: "",
      kioskUiOutAdvFile2: "",
      kioskUiOutAdvFile3: "",
      kioskUiOutAdvFile4: "",
      kioskUiOutAdvFile5: "",
      kioskUiOutAdvFile6: "",
      kioskUiOutAdvFile7: "",
      kioskUiOutAdvFile8: "",
      kioskUiOutAdvFile9: "",
      kioskUiShowSigSmiley: false,
      kioskUiTabletView: false,
      kioskUiSigHideAdvIn: true,
      kioskUiSigHideAdvOut: true,
      kioskUiSigInAdvFile1: "",
      kioskUiSigInAdvFile10: "",
      kioskUiSigInAdvFile2: "",
      kioskUiSigInAdvFile3: "",
      kioskUiSigInAdvFile4: "",
      kioskUiSigInAdvFile5: "",
      kioskUiSigInAdvFile6: "",
      kioskUiSigInAdvFile7: "",
      kioskUiSigInAdvFile8: "",
      kioskUiSigInAdvFile9: "",
      kioskUiSigOutAdvFile1: "",
      kioskUiSigOutAdvFile10: "",
      kioskUiSigOutAdvFile2: "",
      kioskUiSigOutAdvFile3: "",
      kioskUiSigOutAdvFile4: "",
      kioskUiSigOutAdvFile5: "",
      kioskUiSigOutAdvFile6: "",
      kioskUiSigOutAdvFile7: "",
      kioskUiSigOutAdvFile8: "",
      kioskUiSigOutAdvFile9: "",
      kioskUiTermTextColor: "",
      kioskUiTermTextSize: "",
      kioskUiTextColor: "",
      kioskUiTextEngEditor: "",
      kioskUiTextSpnEditor: "",
      kioskUiTitleTextColor: "",
      kioskUiVehicleConfig:false,
      kioskUiWaiverScroll:false,
      noCheckIn: false,
      retToPageSize: "",
      retToPageSizeM: "",
      retToPageText: "",
      retToPageTextSpanish: "",
      retToPageType: "",
      s3Id: null,
      shortcode: null,
      showCoupons: false,
      showLoyaltyReward: true,
      siteName: "",
      smartMatching: false,
      spanishKeyword: "",
      spanishLocation: "",
      spanishVipClubCheckboxText: "",
      spanishVipClubHoverText: "",
      titleSize: "",
      titleSizeM: "",
      titleText: "",
      titleTextSpanish: "",
      titleType: "",
      tncSize: "",
      tncSizeM: "",
      tncText: "",
      tncTextSpanish: "",
      tncType: "",
      // titleTypeM: "",
      // titleText: "",
      urgId: null,
      widthForDesktop: "",
      widthForMobile: "",
    };

    const colorPickerOptions: any = {
      homeButtonBgColor: {
        onOpen: false,
      },
      homeButtonColor: {
        onOpen: false,
      },
      howitworksBgColor: {
        onOpen: false,
      },
      howitworksColor: {
        onOpen: false,
      },
      jiSignUpUiBackgroundColor: {
        onOpen: false,
      },
      jiSignUpUiFontColor: {
        onOpen: false,
      },
      kioskUiBackgroundColor: {
        onOpen: false,
      },
      kioskUiButtonDisabledColor: {
        onOpen: false,
      },
      kioskUiButtonErrorColor: {
        onOpen: false,
      },
      kioskUiButtonKeyColor: {
        onOpen: false,
      },
      kioskUiButtonPrimaryColor: {
        onOpen: false,
      },
      kioskUiButtonSuccessColor: {
        onOpen: false,
      },
      kioskUiContinueBtnTextColor: {
        onOpen: false,
      },
      kioskUiLogoBorderColor: {
        onOpen: false,
      },
      kioskUiTermTextColor: {
        onOpen: false,
      },
      kioskUiTextColor: {
        onOpen: false,
      },
      kioskUiTitleTextColor: {
        onOpen: false,
      },
    };

    if ("allowOptOut" in site) {
      siteOptions.allowOptOut = site.allowOptOut;
    }
    if ("descSize" in site) {
      siteOptions.descSize = site.descSize;
    }
    if ("descSizeM" in site) {
      siteOptions.descSizeM = site.descSizeM;
    }
    if ("descType" in site) {
      siteOptions.descType = site.descType;
    }
    if ("descText" in site) {
      siteOptions.descText = site.descText;
    }
    if ("descTextSecondline" in site) {
      siteOptions.descTextSecondline = site.descTextSecondline;
    }
    if ("descTextSpanish" in site) {
      siteOptions.descTextSpanish = site.descTextSpanish;
    }
    if ("descTextSpanishSecondline" in site) {
      siteOptions.descTextSpanishSecondline = site.descTextSpanishSecondline;
    }
    // if ("descTypeM" in site) {
    //   siteOptions.descTypeM = site.descTypeM;
    // }
    if ("disableKeyboard" in site) {
      siteOptions.disableKeyboard = site.disableKeyboard || false;
    }
    if ("guid" in site) {
      siteOptions.guid = site.guid;
    }
    if ("kioskName" in site) {
      siteOptions.kioskName = site.kioskName;
    }
    if ("kioskNameEs" in site) {
      siteOptions.kioskNameEs = site.kioskNameEs;
    }
    if ("noCheckIn" in site) {
      siteOptions.noCheckIn = site.noCheckIn || false;
    }
    if ("s3Id" in site) {
      siteOptions.s3Id = site.s3Id || null;
    }
    if ("showCoupons" in site) {
      siteOptions.showCoupons = site.showCoupons;
    }
    if ("enableExpanolBtn" in site) {
      siteOptions.enableExpanolBtn = site.enableExpanolBtn;
    }
    if ("smartMatching" in site) {
      siteOptions.smartMatching = site.smartMatching;
    }
    if ("enableItalic" in site) {
      siteOptions.enableItalic = site.enableItalic;
    }
    if ("enableRowInTxtMsg" in site) {
      siteOptions.enableRowInTxtMsg = site.enableRowInTxtMsg;
    }
    if ("enableVipClub" in site) {
      siteOptions.enableVipClub = site.enableVipClub;
    }
    if ("showLoyaltyReward" in site) {
      siteOptions.showLoyaltyReward = site.showLoyaltyReward;
    }
    if ("siteName" in site) {
      siteOptions.siteName = site.siteName;
    }
    // if ("titleText" in site) {
    //   siteOptions.titleText = site.titleText;
    // }
    if ("titleSize" in site) {
      siteOptions.titleSize = site.titleSize;
    }
    if ("retToPageSize" in site) {
      siteOptions.retToPageSize = site.retToPageSize;
    }
    if ("accessDashboardSize" in site) {
      siteOptions.accessDashboardSize = site.accessDashboardSize;
    }
    if ("accessDashboardSizeM" in site) {
      siteOptions.accessDashboardSizeM = site.accessDashboardSizeM;
    }
    if ("accessDashboardType" in site) {
      siteOptions.accessDashboardType = site.accessDashboardType;
    }
    if ("accessDashboardText" in site) {
      siteOptions.accessDashboardText = site.accessDashboardText;
    }
    if ("accessDashboardTextSpanish" in site) {
      siteOptions.accessDashboardTextSpanish = site.accessDashboardTextSpanish;
    }
    if ("retToPageSizeM" in site) {
      siteOptions.retToPageSizeM = site.retToPageSizeM;
    }
    if ("retToPageType" in site) {
      siteOptions.retToPageType = site.retToPageType;
    }
    if ("retToPageText" in site) {
      siteOptions.retToPageText = site.retToPageText;
    }
    if ("retToPageTextSpanish" in site) {
      siteOptions.retToPageTextSpanish = site.retToPageTextSpanish;
    }
    if ("tncSize" in site) {
      siteOptions.tncSize = site.tncSize;
    }
    if ("tncSizeM" in site) {
      siteOptions.tncSizeM = site.tncSizeM;
    }
    if ("tncType" in site) {
      siteOptions.tncType = site.tncType;
    }
    if ("tncText" in site) {
      siteOptions.tncText = site.tncText;
    }
    if ("tncTextSpanish" in site) {
      siteOptions.tncTextSpanish = site.tncTextSpanish;
    }
    if ("titleSizeM" in site) {
      siteOptions.titleSizeM = site.titleSizeM;
    }
    if ("titleType" in site) {
      siteOptions.titleType = site.titleType;
    }
    if ("titleText" in site) {
      siteOptions.titleText = site.titleText;
    }
    if ("titleTextSpanish" in site) {
      siteOptions.titleTextSpanish = site.titleTextSpanish;
    }
    // if ("titleTypeM" in site) {
    //   siteOptions.titleTypeM = site.titleTypeM;
    // }
    if ("isArchive" in site) {
      siteOptions.isArchive = site.isArchive;
    }
    if ("urgId" in site) {
      siteOptions.urgId = site.urgId || null;
    }
    if ("widthForDesktop" in site) {
      siteOptions.widthForDesktop = site.widthForDesktop || "500px";
    }
    if ("widthForMobile" in site) {
      siteOptions.widthForMobile = site.widthForMobile || "500px";
    }
    if ("heightForDesktop" in site) {
      siteOptions.heightForDesktop = site.heightForDesktop || "200px";
    }
    if ("heightForMobile" in site) {
      siteOptions.heightForMobile = site.heightForMobile || "200px";
    }
    if ("homeBtnUrl" in site) {
      siteOptions.homeBtnUrl = site.homeBtnUrl || "";
    }
    if ("englishKeyword" in site) {
      siteOptions.englishKeyword = site.englishKeyword || "";
    }
    if ("englishLocation" in site) {
      siteOptions.englishLocation = site.englishLocation || "";
    }
    if ("englishVipClubCheckboxText" in site) {
      siteOptions.englishVipClubCheckboxText = site.englishVipClubCheckboxText || "";
    }
    if ("englishVipClubHoverText" in site) {
      siteOptions.englishVipClubHoverText = site.englishVipClubHoverText || "";
    }
    if ("spanishKeyword" in site) {
      siteOptions.spanishKeyword = site.spanishKeyword || "";
    }
    if ("spanishLocation" in site) {
      siteOptions.spanishLocation = site.spanishLocation || "";
    }
    if ("spanishVipClubCheckboxText" in site) {
      siteOptions.spanishVipClubCheckboxText = site.spanishVipClubCheckboxText || "";
    }
    if ("spanishVipClubHoverText" in site) {
      siteOptions.spanishVipClubHoverText = site.spanishVipClubHoverText || "";
    }
    if ("homeButtonText" in site) {
      siteOptions.homeButtonText = site.homeButtonText || "";
    }
    if ("homeButtonColor" in site) {
      siteOptions.homeButtonColor = site.homeButtonColor || "";
    }
    if ("homeButtonBgColor" in site) {
      siteOptions.homeButtonBgColor = site.homeButtonBgColor || "";
    }
    if ("homeButtonTextSpanish" in site) {
      siteOptions.homeButtonTextSpanish = site.homeButtonTextSpanish || "";
    }
    if ("helpMenu" in site) {
      siteOptions.helpMenu = site.helpMenu || "";
    }
    if ("helpMenus" in site) {
      siteOptions.helpMenus = site.helpMenus || "";
    }
    if ("howitworksText" in site) {
      siteOptions.howitworksText = site.howitworksText || "";
    }
    if ("howitworksBgColor" in site) {
      siteOptions.howitworksBgColor = site.howitworksBgColor || "";
    }
    if ("howitworksColor" in site) {
      siteOptions.howitworksColor = site.howitworksColor || "";
    }
    if ("howitworksTexts" in site) {
      siteOptions.howitworksTexts = site.howitworksTexts || "";
    }
    if ("homeBtnEnable" in site) {
      siteOptions.homeBtnEnable = site.homeBtnEnable;
    }
    if ("kioskUiBackgroundColor" in site) {
      siteOptions.kioskUiBackgroundColor = site.kioskUiBackgroundColor || null;
      colorPickerOptions.kioskUiBackgroundColor.background = site.kioskUiBackgroundColor || "#000000";
    }
    if ("kioskUiButtonDisabledColor" in site) {
      siteOptions.kioskUiButtonDisabledColor = site.kioskUiButtonDisabledColor || null;
      colorPickerOptions.kioskUiButtonDisabledColor.background = site.kioskUiButtonDisabledColor || "#000000";
    }
    if ("kioskUiButtonErrorColor" in site) {
      siteOptions.kioskUiButtonErrorColor = site.kioskUiButtonErrorColor || null;
      colorPickerOptions.kioskUiButtonErrorColor.background = site.kioskUiButtonErrorColor || "#000000";
    }
    if ("kioskUiButtonKeyColor" in site) {
      siteOptions.kioskUiButtonKeyColor = site.kioskUiButtonKeyColor || null;
      colorPickerOptions.kioskUiButtonKeyColor.background = site.kioskUiButtonKeyColor || "#000000";
    }
    if ("kioskUiButtonPrimaryColor" in site) {
      siteOptions.kioskUiButtonPrimaryColor = site.kioskUiButtonPrimaryColor || null;
      colorPickerOptions.kioskUiButtonPrimaryColor.background = site.kioskUiButtonPrimaryColor || "#000000";
    }
    if ("kioskUiButtonSuccessColor" in site) {
      siteOptions.kioskUiButtonSuccessColor = site.kioskUiButtonSuccessColor || null;
      colorPickerOptions.kioskUiButtonSuccessColor.background = site.kioskUiButtonSuccessColor || "#000000";
    }
    if ("kioskUiContinueBtnTextColor" in site) {
      siteOptions.kioskUiContinueBtnTextColor = site.kioskUiContinueBtnTextColor || null;
      colorPickerOptions.kioskUiContinueBtnTextColor.background = site.kioskUiContinueBtnTextColor || "#000000";
    }
    if ("kioskUiLogoBorderColor" in site) {
      siteOptions.kioskUiLogoBorderColor = site.kioskUiLogoBorderColor || null;
      colorPickerOptions.kioskUiLogoBorderColor.background = site.kioskUiLogoBorderColor || "#000000";
    }
    if ("kioskUiTermTextColor" in site) {
      siteOptions.kioskUiTermTextColor = site.kioskUiTermTextColor || null;
      colorPickerOptions.kioskUiTermTextColor.background = site.kioskUiTermTextColor || "#000000";
    }
    if ("kioskUiTextColor" in site) {
      siteOptions.kioskUiTextColor = site.kioskUiTextColor || null;
      colorPickerOptions.kioskUiTextColor.background = site.kioskUiTextColor || "#000000";
    }
    if ("kioskUiTextEngEditor" in site) {
      siteOptions.kioskUiTextEngEditor = site.kioskUiTextEngEditor || "";
    }
    if ("kioskUiTextSpnEditor" in site) {
      siteOptions.kioskUiTextSpnEditor = site.kioskUiTextSpnEditor || "";
    }
    if ("kioskUiTitleTextColor" in site) {
      siteOptions.kioskUiTitleTextColor = site.kioskUiTitleTextColor || null;
      colorPickerOptions.kioskUiTitleTextColor.background = site.kioskUiTitleTextColor || "#000000";
    }
    if ("jiSignUpUiBackgroundColor" in site) {
      siteOptions.jiSignUpUiBackgroundColor = site.jiSignUpUiBackgroundColor || null;
      colorPickerOptions.jiSignUpUiBackgroundColor.background = site.jiSignUpUiBackgroundColor || "#000000";
    }
    if ("jiSignUpUiFontColor" in site) {
      siteOptions.jiSignUpUiFontColor = site.jiSignUpUiFontColor || null;
      colorPickerOptions.jiSignUpUiFontColor.background = site.jiSignUpUiFontColor || "#000000";
    }
    if ("kioskUiTermTextSize" in site) {
      siteOptions.kioskUiTermTextSize = site.kioskUiTermTextSize;
    }
    if ("kioskUiHideAdvIn" in site) {
      siteOptions.kioskUiHideAdvIn = site.kioskUiHideAdvIn;
    }
    if ("kioskUiHideAdvOut" in site) {
      siteOptions.kioskUiHideAdvOut = site.kioskUiHideAdvOut;
    }
    if ("kioskUiHideCity" in site) {
      siteOptions.kioskUiHideCity = site.kioskUiHideCity;
    }
    if ("kioskUiHideContBtn" in site) {
      siteOptions.kioskUiHideContBtn = site.kioskUiHideContBtn;
    }
    if ("kioskUiWaiverScroll" in site) {
      siteOptions.kioskUiWaiverScroll = site.kioskUiWaiverScroll;
    }
    if ("kioskUiVehicleConfig" in site) {
      siteOptions.kioskUiVehicleConfig = site.kioskUiVehicleConfig;
    }
    if ("kioskUiHideDefaultWaiver" in site) {
      siteOptions.kioskUiHideDefaultWaiver = site.kioskUiHideDefaultWaiver;
    }
    if ("howitworksImg" in site) {
      siteOptions.howitworksImg = site.howitworksImg;
    }
    if ("kioskUiInAdvFile1" in site) {
      siteOptions.kioskUiInAdvFile1 = site.kioskUiInAdvFile1;
    }
    if ("kioskUiInAdvFile2" in site) {
      siteOptions.kioskUiInAdvFile2 = site.kioskUiInAdvFile2;
    }
    if ("kioskUiInAdvFile3" in site) {
      siteOptions.kioskUiInAdvFile3 = site.kioskUiInAdvFile3;
    }
    if ("kioskUiInAdvFile4" in site) {
      siteOptions.kioskUiInAdvFile4 = site.kioskUiInAdvFile4;
    }
    if ("kioskUiInAdvFile5" in site) {
      siteOptions.kioskUiInAdvFile5 = site.kioskUiInAdvFile5;
    }
    if ("kioskUiInAdvFile6" in site) {
      siteOptions.kioskUiInAdvFile6 = site.kioskUiInAdvFile6;
    }
    if ("kioskUiInAdvFile7" in site) {
      siteOptions.kioskUiInAdvFile7 = site.kioskUiInAdvFile7;
    }
    if ("kioskUiInAdvFile8" in site) {
      siteOptions.kioskUiInAdvFile8 = site.kioskUiInAdvFile8;
    }
    if ("kioskUiInAdvFile9" in site) {
      siteOptions.kioskUiInAdvFile9 = site.kioskUiInAdvFile9;
    }
    if ("kioskUiInAdvFile10" in site) {
      siteOptions.kioskUiInAdvFile10 = site.kioskUiInAdvFile10;
    }
    if ("kioskUiOutAdvFile1" in site) {
      siteOptions.kioskUiOutAdvFile1 = site.kioskUiOutAdvFile1;
    }
    if ("kioskUiOutAdvFile2" in site) {
      siteOptions.kioskUiOutAdvFile2 = site.kioskUiOutAdvFile2;
    }
    if ("kioskUiOutAdvFile3" in site) {
      siteOptions.kioskUiOutAdvFile3 = site.kioskUiOutAdvFile3;
    }
    if ("kioskUiOutAdvFile4" in site) {
      siteOptions.kioskUiOutAdvFile4 = site.kioskUiOutAdvFile4;
    }
    if ("kioskUiOutAdvFile5" in site) {
      siteOptions.kioskUiOutAdvFile5 = site.kioskUiOutAdvFile5;
    }
    if ("kioskUiOutAdvFile6" in site) {
      siteOptions.kioskUiOutAdvFile6 = site.kioskUiOutAdvFile6;
    }
    if ("kioskUiOutAdvFile7" in site) {
      siteOptions.kioskUiOutAdvFile7 = site.kioskUiOutAdvFile7;
    }
    if ("kioskUiOutAdvFile8" in site) {
      siteOptions.kioskUiOutAdvFile8 = site.kioskUiOutAdvFile8;
    }
    if ("kioskUiOutAdvFile9" in site) {
      siteOptions.kioskUiOutAdvFile9 = site.kioskUiOutAdvFile9;
    }
    if ("kioskUiOutAdvFile10" in site) {
      siteOptions.kioskUiOutAdvFile10 = site.kioskUiOutAdvFile10;
    }
    if ("kioskUiAdvDelaySec" in site) {
      siteOptions.kioskUiAdvDelaySec = site.kioskUiAdvDelaySec;
    }
    if ("kioskUiAdvWidth" in site) {
      siteOptions.kioskUiAdvWidth = site.kioskUiAdvWidth;
    }
    if ("kioskUiAdvHeight" in site) {
      siteOptions.kioskUiAdvHeight = site.kioskUiAdvHeight;
    }
    if ("kioskUiAdvTop" in site) {
      siteOptions.kioskUiAdvTop = site.kioskUiAdvTop;
    }
    if ("kioskUiAdvBottom" in site) {
      siteOptions.kioskUiAdvBottom = site.kioskUiAdvBottom;
    }
    if ("kioskUiLogoHeight" in site) {
      siteOptions.kioskUiLogoHeight = site.kioskUiLogoHeight;
    }
    if ("kioskUiLogoWidth" in site) {
      siteOptions.kioskUiLogoWidth = site.kioskUiLogoWidth;
    }
    if ("kioskUiShowSigSmiley" in site) {
      siteOptions.kioskUiShowSigSmiley = site.kioskUiShowSigSmiley;
    }
    if ("kioskUiAllInOneCheckIn" in site) {
      siteOptions.kioskUiAllInOneCheckIn = site.kioskUiAllInOneCheckIn;
    }
    if ("kioskUiLogoBorderEnable" in site) {
      siteOptions.kioskUiLogoBorderEnable = site.kioskUiLogoBorderEnable;
    }
    if ("kioskUiTabletView" in site) {
      siteOptions.kioskUiTabletView = site.kioskUiTabletView;
    }
    if ("kioskUiSigHideAdvIn" in site) {
      siteOptions.kioskUiSigHideAdvIn = site.kioskUiSigHideAdvIn;
    }
    if ("kioskUiSigHideAdvOut" in site) {
      siteOptions.kioskUiSigHideAdvOut = site.kioskUiSigHideAdvOut;
    }
    if ("kioskUiSigInAdvFile1" in site) {
      siteOptions.kioskUiSigInAdvFile1 = site.kioskUiSigInAdvFile1;
    }
    if ("kioskUiSigInAdvFile2" in site) {
      siteOptions.kioskUiSigInAdvFile2 = site.kioskUiSigInAdvFile2;
    }
    if ("kioskUiSigInAdvFile3" in site) {
      siteOptions.kioskUiSigInAdvFile3 = site.kioskUiSigInAdvFile3;
    }
    if ("kioskUiSigInAdvFile4" in site) {
      siteOptions.kioskUiSigInAdvFile4 = site.kioskUiSigInAdvFile4;
    }
    if ("kioskUiSigInAdvFile5" in site) {
      siteOptions.kioskUiSigInAdvFile5 = site.kioskUiSigInAdvFile5;
    }
    if ("kioskUiSigInAdvFile6" in site) {
      siteOptions.kioskUiSigInAdvFile6 = site.kioskUiSigInAdvFile6;
    }
    if ("kioskUiSigInAdvFile7" in site) {
      siteOptions.kioskUiSigInAdvFile7 = site.kioskUiSigInAdvFile7;
    }
    if ("kioskUiSigInAdvFile8" in site) {
      siteOptions.kioskUiSigInAdvFile8 = site.kioskUiSigInAdvFile8;
    }
    if ("kioskUiSigInAdvFile9" in site) {
      siteOptions.kioskUiSigInAdvFile9 = site.kioskUiSigInAdvFile9;
    }
    if ("kioskUiSigInAdvFile10" in site) {
      siteOptions.kioskUiSigInAdvFile10 = site.kioskUiSigInAdvFile10;
    }
    if ("kioskUiSigOutAdvFile1" in site) {
      siteOptions.kioskUiSigOutAdvFile1 = site.kioskUiSigOutAdvFile1;
    }
    if ("kioskUiSigOutAdvFile2" in site) {
      siteOptions.kioskUiSigOutAdvFile2 = site.kioskUiSigOutAdvFile2;
    }
    if ("kioskUiSigOutAdvFile3" in site) {
      siteOptions.kioskUiSigOutAdvFile3 = site.kioskUiSigOutAdvFile3;
    }
    if ("kioskUiSigOutAdvFile4" in site) {
      siteOptions.kioskUiSigOutAdvFile4 = site.kioskUiSigOutAdvFile4;
    }
    if ("kioskUiSigOutAdvFile5" in site) {
      siteOptions.kioskUiSigOutAdvFile5 = site.kioskUiSigOutAdvFile5;
    }
    if ("kioskUiSigOutAdvFile6" in site) {
      siteOptions.kioskUiSigOutAdvFile6 = site.kioskUiSigOutAdvFile6;
    }
    if ("kioskUiSigOutAdvFile7" in site) {
      siteOptions.kioskUiSigOutAdvFile7 = site.kioskUiSigOutAdvFile7;
    }
    if ("kioskUiSigOutAdvFile8" in site) {
      siteOptions.kioskUiSigOutAdvFile8 = site.kioskUiSigOutAdvFile8;
    }
    if ("kioskUiSigOutAdvFile9" in site) {
      siteOptions.kioskUiSigOutAdvFile9 = site.kioskUiSigOutAdvFile9;
    }
    if ("kioskUiSigOutAdvFile10" in site) {
      siteOptions.kioskUiSigOutAdvFile10 = site.kioskUiSigOutAdvFile10;
    }

    this.setState({
      colorPickerOptions,
      siteOptions,
      siteOptionsDisabled: {
        accessDashboardSize: false,
        accessDashboardSizeM: false,
        accessDashboardText: false,
        accessDashboardTextSpanish: false,
        accessDashboardType: false,
        allowOptOut: false,
        descSize: false,
        descSizeM: false,
        descText: false,
        descTextSecondline: false,
        descTextSpanish: false,
        descTextSpanishSecondline: false,
        descType: false,
        // descTypeM: false,
        disableKeyboard: false,
        enableExpanolBtn: false,
        enableItalic: false,
        enableRowInTxtMsg: false,
        enableVipClub: false,
        englishKeyword: false,
        englishLocation: false,
        englishVipClubCheckboxText: false,
        englishVipClubHoverText: false,
        guid: false,
        heightForDesktop: false,
        heightForMobile: false,
        helpMenu: false,
        helpMenus: false,
        homeBtnEnable: false,
        homeBtnUrl: false,
        homeButtonBgColor: false,
        homeButtonColor: false,
        homeButtonText: false,
        homeButtonTextSpanish: false,
        howitworksBgColor: false,
        howitworksColor: false,
        howitworksImg: false,
        howitworksText: false,
        howitworksTexts: false,
        isArchive: false,
        jiSignUpUiBackgroundColor: false,
        jiSignUpUiFontColor: false,
        keyword: false,
        keywordEs: false,
        kioskName: false,
        kioskNameEs: false,
        kioskUiAdvBottom: false,
        kioskUiAdvDelaySec: false,
        kioskUiAdvHeight: false,
        kioskUiAdvTop: false,
        kioskUiAdvWidth: false,
        kioskUiBackgroundColor: false,
        kioskUiButtonDisabledColor: false,
        kioskUiButtonErrorColor: false,
        kioskUiButtonKeyColor: false,
        kioskUiButtonPrimaryColor: false,
        kioskUiButtonSuccessColor: false,
        kioskUiContinueBtnTextColor: false,
        kioskUiHideAdvIn: false,
        kioskUiHideAdvOut: false,
        kioskUiHideCity: false,
        kioskUiHideContBtn: false,
        kioskUiHideDefaultWaiver: false,
        kioskUiInAdvFile1: false,
        kioskUiInAdvFile10: false,
        kioskUiInAdvFile2: false,
        kioskUiInAdvFile3: false,
        kioskUiInAdvFile4: false,
        kioskUiInAdvFile5: false,
        kioskUiInAdvFile6: false,
        kioskUiInAdvFile7: false,
        kioskUiInAdvFile8: false,
        kioskUiInAdvFile9: false,
        kioskUiAllInOneCheckIn: false,
        kioskUiLogoBorderColor: false,
        kioskUiLogoBorderEnable: false,
        kioskUiLogoHeight: false,
        kioskUiLogoWidth: false,
        kioskUiOutAdvFile1: false,
        kioskUiOutAdvFile10: false,
        kioskUiOutAdvFile2: false,
        kioskUiOutAdvFile3: false,
        kioskUiOutAdvFile4: false,
        kioskUiOutAdvFile5: false,
        kioskUiOutAdvFile6: false,
        kioskUiOutAdvFile7: false,
        kioskUiOutAdvFile8: false,
        kioskUiOutAdvFile9: false,
        kioskUiShowSigSmiley: false,
        kioskUiTabletView: false,
        kioskUiSigHideAdvIn: false,
        kioskUiSigHideAdvOut: false,
        kioskUiSigInAdvFile1: false,
        kioskUiSigInAdvFile10: false,
        kioskUiSigInAdvFile2: false,
        kioskUiSigInAdvFile3: false,
        kioskUiSigInAdvFile4: false,
        kioskUiSigInAdvFile5: false,
        kioskUiSigInAdvFile6: false,
        kioskUiSigInAdvFile7: false,
        kioskUiSigInAdvFile8: false,
        kioskUiSigInAdvFile9: false,
        kioskUiSigOutAdvFile1: false,
        kioskUiSigOutAdvFile10: false,
        kioskUiSigOutAdvFile2: false,
        kioskUiSigOutAdvFile3: false,
        kioskUiSigOutAdvFile4: false,
        kioskUiSigOutAdvFile5: false,
        kioskUiSigOutAdvFile6: false,
        kioskUiSigOutAdvFile7: false,
        kioskUiSigOutAdvFile8: false,
        kioskUiSigOutAdvFile9: false,
        kioskUiTermTextColor: false,
        kioskUiTermTextSize: false,
        kioskUiTextColor: false,
        kioskUiTextEngEditor: false,
        kioskUiTextSpnEditor: false,
        kioskUiTitleTextColor: false,
        kioskUiVehicleConfig: false,
        kioskUiWaiverScroll: false,
        noCheckIn: false,
        optInField: false,
        retToPageSize: false,
        retToPageSizeM: false,
        retToPageText: false,
        retToPageTextSpanish: false,
        retToPageType: false,
        s3Id: false,
        shortcode: false,
        showCoupons: false,
        showLoyaltyReward: false,
        siteName: false,
        smartMatching: false,
        spanishKeyword: false,
        spanishLocation: false,
        spanishVipClubCheckboxText: false,
        spanishVipClubHoverText: false,
        // titleText: false,
        titleSize: false,
        titleSizeM: false,
        titleText: false,
        titleTextSpanish: false,
        titleType: false,
        tncSize: false,
        tncSizeM: false,
        tncText: false,
        tncTextSpanish: false,
        tncType: false,
        // titleTypeM: false,
        urgId: false,
        widthForDesktop: false,
        widthForMobile: false,
      },
    });
  };

  // private saveEngEditorData = () =>{
  //   // console.log(this.state.tinyEngEditor.getContent());
  //   const name = 'kioskUiTextEngEditor';
  //   const data = this.state.tinyEngEditor.getContent();
  //   this.sendOptionsUpdate({ name, value: data });
  // }

  // private saveSpnEditorData = () =>{
  //   // console.log(this.state.tinyEngEditor.getContent());
  //   const name = 'kioskUiTextSpnEditor';
  //   const data = this.state.tinySpnEditor.getContent();
  //   this.sendOptionsUpdate({ name, value: data });
  // }

  private handleSwitchChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { checked, name } = event.currentTarget;

    if (isValidSwitchInputName(name)) {
      const siteOptionsDisabled = { ...this.state.siteOptionsDisabled };
      const siteOptions = { ...this.state.siteOptions };

      siteOptionsDisabled[name] = true;
      siteOptions[name] = checked;

      this.setState({ siteOptions, siteOptionsDisabled });

      this.sendOptionsUpdate({ name, value: checked });
    }
  };

  private handleTextChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;

    if (isValidTextInputName(name)) {
      const siteOptions: any = { ...this.state.siteOptions };

      siteOptions[name] = value;

      this.setState({ siteOptions });
    }
  };
  private handleTextAreaChange = (event: React.FormEvent<HTMLTextAreaElement>) => {
    const { name, value } = event.currentTarget;
    if (isValidTextInputName(name)) {
      const siteOptions: any = { ...this.state.siteOptions };

      siteOptions[name] = value;

      this.setState({ siteOptions });
    }
  };
  private handleShortcodeChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = event.currentTarget;

    const isValidShortcode1 = value.match(/^\d{5}$/g) ? true : false;
    const isValidShortcode2 = value.match(/^\d{11}$/g) ? true : false;
    if (isValidShortcode1 || isValidShortcode2) {
      this.setState({ shortcodeDisabled: false });
    } else {
      this.setState({ shortcodeDisabled: true });
    }

    if (isValidTextInputName(name)) {
      this.setState({ shortcode: value });
    }
  };

  private handleChangeButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { name, value } = event.currentTarget;

    if (isValidTextInputName(name)) {
      this.sendOptionsUpdate({ name, value });
    }
  };

  private handleChangeButtonForTextarea = (name, value) => {
    if (isValidTextInputName(name)) {
      this.sendOptionsUpdate({ name, value });
    }
  };

  private handleSelect = ({ currentTarget: { name, value } }: React.ChangeEvent<HTMLSelectElement>) => {
    if (isValidTextInputName(name)) {
      this.sendOptionsUpdate({ name, value });
    }
  };

  private sizeArrayFnc = () => {
    let t = "";
    for (let i = 1; i <= 50; i++) {
      t = i + "px";
      this.sizeArray.push(t);
    }

    for (let s = 1; s <= 20; s++) {
      this.delaySecondArray.push({ label: s + " second(s)", value: s * 1000 });
    }
  };

  private onClickPicker = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { name } = event.currentTarget;
    if (isValidTextInputName(name)) {
      const colorPickerOptions = { ...this.state.colorPickerOptions };
      colorPickerOptions[name].onOpen = !colorPickerOptions[name].onOpen;
      this.setState({ colorPickerOptions });
    }
  };

  private handleChangePicker = (color, name: string) => {
    if (isValidTextInputName(name)) {
      const colorPickerOptions = { ...this.state.colorPickerOptions };
      colorPickerOptions[name].background = color.hex;

      const siteOptions = { ...this.state.siteOptions };
      siteOptions[name] = color.hex;
      this.setState({ colorPickerOptions, siteOptions });
    }
  };

  private handleShortcodeChangeButton = (event: React.MouseEvent<HTMLButtonElement>) => {
    const { name, value } = event.currentTarget;

    if (isValidTextInputName(name)) {
      this.saveShortcode(value);
      console.log(name, value);
    }
  };

  private sendOptionsUpdate = async ({ name, value }: { name: InputName; value: boolean | string }) => {
    const { onUpdateSiteOptions, businessId, siteId } = this.props;

    const siteOptionsDisabled = { ...this.state.siteOptionsDisabled };
    const originalSiteOptions = { ...this.state.siteOptions };
    const siteOptions = { ...originalSiteOptions, [name]: value };

    siteOptionsDisabled[name] = true;

    this.setState({ siteOptionsDisabled });

    if (businessId && siteId) {
      const result = await onUpdateSiteOptions({
        businessId,
        siteId,
        siteOptions,
      });

      this.setState({
        siteOptions: result !== null ? siteOptions : originalSiteOptions,
        siteOptionsDisabled: siteOptionsEnabled,
      });
    } else {
      console.log("businessId:", businessId);
      console.log("siteId:", siteId);
      this.setState({
        siteOptions: originalSiteOptions,
        siteOptionsDisabled: siteOptionsEnabled,
      });
    }
  };

  private handleUploadSuccess = (key: InputName) => (filename: string) => {
    firebase
      .storage()
      .ref("kiosk-inside-advertising")
      .child(filename)
      .getDownloadURL()
      .then(async (url) => {
        this.sendOptionsUpdate({ name: key, value: url });
      });
  };

  private handleRemoveAdvUrl = (key: InputName) => {
    const confirm = window.confirm("Are you sure?");
    if (confirm) {
      this.sendOptionsUpdate({ name: key, value: "" });
    }
  };

  private handleHowItWorksUploadSuccess = (key: InputName) => (filename: string) => {
    firebase
      .storage()
      .ref("how-it-works")
      .child(filename)
      .getDownloadURL()
      .then(async (url) => {
        this.sendOptionsUpdate({ name: key, value: url });
      });
  };

  private renderSiteName = (path: any) => {
    if (path.includes("-")) {
      let words = path.split("-");
      words = words.filter((e) => e !== "vehicles"); // remove 'vehicles' word from the site name

      const uppercase = words.map((str) => {
        return str.charAt(0).toUpperCase() + str.substring(1);
      });
      return uppercase.join(" ");
    }
    return path.charAt(0).toUpperCase() + path.substring(1);
  };

  private handleRemoveHowItWorks = (key: InputName) => {
    const confirm = window.confirm("Are you sure?");
    if (confirm) {
      this.sendOptionsUpdate({ name: key, value: "" });
    }
  };

  private isArchiveSite = (value: string) => (e) => {
    // const { businessId, siteId } = this.props;

    // console.log("businessId", businessId, "siteId", siteId);

    if (value === "1") {
      if (!confirm("Are you sure?")) {
        return;
      }
    }

    const name = "isArchive";
    this.sendOptionsUpdate({ name, value });
  };
}

const mapDispatchToProps = {
  onUpdateSiteOptions: updateSiteOptions,
};

export default connect<{}, ISiteTreeOptionsDispatchProps, ISiteTreeOptionsOwnProps>(
  null,
  mapDispatchToProps
)(SiteTreeOptions);



// WEBPACK FOOTER //
// ./src/components/SiteTreeOptions.tsx